export const testV3 = {
	id: "ATPNfV1Lye",
	tracks: [
	  {
		id: "ycY5jx0Hpz",
		type: "caption",
		items: [
		  "uvgcp8zsvO",
		  "XQ3bP3i9lg",
		  "CMNvZJgPvy",
		  "aVI8ZJjjJq",
		  "TfDAfb1Yz6",
		  "ipKBwjNfT2",
		  "kZw1Jt9twx",
		  "ZK8MskuIGO",
		  "siDdk3iJYo",
		  "mxpizvOXKk",
		  "fwvjrCtqv4",
		  "iq6RXhoKRt",
		  "aoLsSSJqzW",
		  "VXR0nkI1Er",
		  "2QBzzaAXn1",
		  "AFQfg9AuDP",
		  "4JFwUk9GmB",
		  "tToHIEWjnd",
		  "V0LkAnG8Gt",
		  "hGcqBOtqQz",
		  "RDUtPKkHG1",
		  "s3r2upxV7q",
		  "i9WiHFwaZx",
		  "XHcNu5RA7j",
		  "LttElnxyNF",
		  "FvtShUoCG7",
		  "uNBr0t57X1",
		  "dSPhLADnfr",
		  "zSX1rAAQRY",
		  "QRdPzwmyAf",
		  "DsYPnfZfR8",
		  "3bgnTk4z7L",
		  "nNq1Dw1Pqy",
		  "BOizRdHuoF",
		  "Hp7FKjH8mI",
		],
		accepts: [
		  "caption",
		],
		maxWordsInPage: 5,
		styles: [
		  {
			property: "textShadow",
			value: "-3px 1px 8px rgba(0, 0, 0, 0.82)",
		  },
		  {
			property: "translate",
			value: "0em 0.25em",
			active: {
			  value: "0em 0em",
			  duration: 0.5,
			},
		  },
		  {
			property: "opacity",
			value: "0",
			active: {
			  value: "1",
			  duration: 0.5,
			},
		  },
		  {
			property: "color",
			value: "#ffffffed",
			active: {
			  value: "#00ffff",
			  duration: 0.3,
			},
			past: {
			  value: "#ffffffed",
			  duration: 0.7,
			},
		  },
		],
	  },
	  {
		id: "49AISjr5aL",
		type: "video",
		items: [
		  "DUEhiZoGqm",
		],
		accepts: [
		  "video",
		],
	  },
	  {
		id: "obxaUI1GeG",
		type: "image",
		items: [
		  "TSCj230DiT",
		],
		accepts: [
		  "image",
		],
	  },
	],
	trackItemIds: [
	  "DUEhiZoGqm",
	  "uvgcp8zsvO",
	  "XQ3bP3i9lg",
	  "CMNvZJgPvy",
	  "aVI8ZJjjJq",
	  "TfDAfb1Yz6",
	  "ipKBwjNfT2",
	  "kZw1Jt9twx",
	  "ZK8MskuIGO",
	  "siDdk3iJYo",
	  "mxpizvOXKk",
	  "fwvjrCtqv4",
	  "iq6RXhoKRt",
	  "aoLsSSJqzW",
	  "VXR0nkI1Er",
	  "2QBzzaAXn1",
	  "AFQfg9AuDP",
	  "4JFwUk9GmB",
	  "tToHIEWjnd",
	  "V0LkAnG8Gt",
	  "hGcqBOtqQz",
	  "RDUtPKkHG1",
	  "s3r2upxV7q",
	  "i9WiHFwaZx",
	  "XHcNu5RA7j",
	  "LttElnxyNF",
	  "FvtShUoCG7",
	  "uNBr0t57X1",
	  "dSPhLADnfr",
	  "zSX1rAAQRY",
	  "QRdPzwmyAf",
	  "DsYPnfZfR8",
	  "3bgnTk4z7L",
	  "nNq1Dw1Pqy",
	  "BOizRdHuoF",
	  "Hp7FKjH8mI",
	  "TSCj230DiT",
	],
	trackItemsMap: {
	  DUEhiZoGqm: {
		id: "DUEhiZoGqm",
		name: "The Hidden Factor Behind Energy & Focus",
		type: "video",
		display: {
		  from: 0,
		  to: 37209.899999999834,
		},
		trim: {
		  from: 0,
		  to: 37209.899999999834,
		},
		details: {
		  width: 1080,
		  height: 1920,
		  opacity: 100,
		  src: "https://remotionlambda-useast1-y47kb5uw61.s3.amazonaws.com/media/cmhs0kvvb000bjl047bj61z9z-y_woFP79F0Q-0-.mp4",
		  volume: 100,
		  borderRadius: 0,
		  borderWidth: 0,
		  borderColor: "#000000",
		  boxShadow: {
			color: "#000000",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  transform: "scale(1)",
		  transformOrigin: "center center",
		  top: "0px",
		  left: "0px",
		  blur: 0,
		  brightness: 100,
		  flipX: false,
		  flipY: false,
		  rotate: "0deg",
		  visibility: "visible",
		  zIndex: 0,
		  asd: {
			status: "completed",
			success: true,
			segment_id: 0,
			timestamp: "",
			result: {
			  detection_results: [
				{
				  frame_number: 0,
				  faces: [
					{
					  x1: 1054,
					  y1: 153,
					  x2: 1316,
					  y2: 415,
					  speaking_score: 2,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 1,
				  faces: [
					{
					  x1: 1054,
					  y1: 153,
					  x2: 1316,
					  y2: 415,
					  speaking_score: 2.199999988079071,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 2,
				  faces: [
					{
					  x1: 1057,
					  y1: 154,
					  x2: 1319,
					  y2: 416,
					  speaking_score: 2.419999980926514,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 3,
				  faces: [
					{
					  x1: 1060,
					  y1: 153,
					  x2: 1323,
					  y2: 416,
					  speaking_score: 2.649999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 4,
				  faces: [
					{
					  x1: 1064,
					  y1: 153,
					  x2: 1327,
					  y2: 417,
					  speaking_score: 3.049999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 5,
				  faces: [
					{
					  x1: 1067,
					  y1: 153,
					  x2: 1331,
					  y2: 417,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 6,
				  faces: [
					{
					  x1: 1068,
					  y1: 155,
					  x2: 1333,
					  y2: 419,
					  speaking_score: 3.566666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 7,
				  faces: [
					{
					  x1: 1069,
					  y1: 156,
					  x2: 1333,
					  y2: 421,
					  speaking_score: 3.783333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 8,
				  faces: [
					{
					  x1: 1070,
					  y1: 160,
					  x2: 1334,
					  y2: 424,
					  speaking_score: 3.933333277702332,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 9,
				  faces: [
					{
					  x1: 1070,
					  y1: 163,
					  x2: 1334,
					  y2: 427,
					  speaking_score: 4.016666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 10,
				  faces: [
					{
					  x1: 1070,
					  y1: 165,
					  x2: 1335,
					  y2: 430,
					  speaking_score: 4.066666603088379,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 11,
				  faces: [
					{
					  x1: 1070,
					  y1: 166,
					  x2: 1335,
					  y2: 431,
					  speaking_score: 4.116666595141093,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 12,
				  faces: [
					{
					  x1: 1070,
					  y1: 168,
					  x2: 1335,
					  y2: 433,
					  speaking_score: 4.016666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 13,
				  faces: [
					{
					  x1: 1071,
					  y1: 168,
					  x2: 1336,
					  y2: 433,
					  speaking_score: 3.733333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 14,
				  faces: [
					{
					  x1: 1071,
					  y1: 168,
					  x2: 1336,
					  y2: 433,
					  speaking_score: 3.449999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 15,
				  faces: [
					{
					  x1: 1072,
					  y1: 168,
					  x2: 1337,
					  y2: 433,
					  speaking_score: 3.200000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 16,
				  faces: [
					{
					  x1: 1072,
					  y1: 168,
					  x2: 1337,
					  y2: 433,
					  speaking_score: 3.016666690508524,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 17,
				  faces: [
					{
					  x1: 1073,
					  y1: 168,
					  x2: 1338,
					  y2: 433,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 18,
				  faces: [
					{
					  x1: 1073,
					  y1: 168,
					  x2: 1338,
					  y2: 433,
					  speaking_score: 2.633333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 19,
				  faces: [
					{
					  x1: 1074,
					  y1: 168,
					  x2: 1339,
					  y2: 433,
					  speaking_score: 2.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 20,
				  faces: [
					{
					  x1: 1075,
					  y1: 168,
					  x2: 1340,
					  y2: 433,
					  speaking_score: 2.283333341280619,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 21,
				  faces: [
					{
					  x1: 1075,
					  y1: 168,
					  x2: 1340,
					  y2: 433,
					  speaking_score: 2.049999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 22,
				  faces: [
					{
					  x1: 1076,
					  y1: 168,
					  x2: 1341,
					  y2: 433,
					  speaking_score: 1.666666656732559,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 23,
				  faces: [
					{
					  x1: 1076,
					  y1: 168,
					  x2: 1341,
					  y2: 433,
					  speaking_score: 1.316666652758916,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 24,
				  faces: [
					{
					  x1: 1076,
					  y1: 168,
					  x2: 1341,
					  y2: 433,
					  speaking_score: 1.033333331346512,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 25,
				  faces: [
					{
					  x1: 1076,
					  y1: 168,
					  x2: 1341,
					  y2: 433,
					  speaking_score: 0.9166666567325592,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 26,
				  faces: [
					{
					  x1: 1076,
					  y1: 168,
					  x2: 1341,
					  y2: 433,
					  speaking_score: 0.9333333273728689,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 27,
				  faces: [
					{
					  x1: 1075,
					  y1: 167,
					  x2: 1342,
					  y2: 434,
					  speaking_score: 1.066666652758916,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 28,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1343,
					  y2: 434,
					  speaking_score: 1.316666662693024,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 29,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1343,
					  y2: 435,
					  speaking_score: 1.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 30,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1343,
					  y2: 435,
					  speaking_score: 1.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 31,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1343,
					  y2: 435,
					  speaking_score: 1.616666674613953,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 32,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1343,
					  y2: 435,
					  speaking_score: 1.633333345254262,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 33,
				  faces: [
					{
					  x1: 1074,
					  y1: 166,
					  x2: 1342,
					  y2: 435,
					  speaking_score: 1.533333361148834,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 34,
				  faces: [
					{
					  x1: 1073,
					  y1: 166,
					  x2: 1342,
					  y2: 435,
					  speaking_score: 1.483333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 35,
				  faces: [
					{
					  x1: 1072,
					  y1: 166,
					  x2: 1341,
					  y2: 434,
					  speaking_score: 1.566666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 36,
				  faces: [
					{
					  x1: 1072,
					  y1: 166,
					  x2: 1340,
					  y2: 435,
					  speaking_score: 1.916666686534882,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 37,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 1.933333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 38,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 1.866666694482167,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 39,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 1.916666706403096,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 40,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 2.066666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 41,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 2.333333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 42,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 2.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 43,
				  faces: [
					{
					  x1: 1072,
					  y1: 168,
					  x2: 1338,
					  y2: 434,
					  speaking_score: 2.933333337306976,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 44,
				  faces: [
					{
					  x1: 1070,
					  y1: 168,
					  x2: 1336,
					  y2: 434,
					  speaking_score: 3.349999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 45,
				  faces: [
					{
					  x1: 1067,
					  y1: 168,
					  x2: 1333,
					  y2: 434,
					  speaking_score: 3.566666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 46,
				  faces: [
					{
					  x1: 1064,
					  y1: 170,
					  x2: 1328,
					  y2: 434,
					  speaking_score: 3.633333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 47,
				  faces: [
					{
					  x1: 1065,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.633333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 48,
				  faces: [
					{
					  x1: 1065,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.666666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 49,
				  faces: [
					{
					  x1: 1065,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.700000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 50,
				  faces: [
					{
					  x1: 1066,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.700000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 51,
				  faces: [
					{
					  x1: 1066,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.716666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 52,
				  faces: [
					{
					  x1: 1066,
					  y1: 171,
					  x2: 1327,
					  y2: 433,
					  speaking_score: 3.700000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 53,
				  faces: [
					{
					  x1: 1067,
					  y1: 170,
					  x2: 1329,
					  y2: 432,
					  speaking_score: 3.566666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 54,
				  faces: [
					{
					  x1: 1068,
					  y1: 170,
					  x2: 1330,
					  y2: 431,
					  speaking_score: 3.316666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 55,
				  faces: [
					{
					  x1: 1070,
					  y1: 169,
					  x2: 1332,
					  y2: 431,
					  speaking_score: 3.049999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 56,
				  faces: [
					{
					  x1: 1070,
					  y1: 169,
					  x2: 1332,
					  y2: 431,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 57,
				  faces: [
					{
					  x1: 1070,
					  y1: 169,
					  x2: 1332,
					  y2: 431,
					  speaking_score: 2.716666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 58,
				  faces: [
					{
					  x1: 1070,
					  y1: 169,
					  x2: 1332,
					  y2: 431,
					  speaking_score: 2.549999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 59,
				  faces: [
					{
					  x1: 1070,
					  y1: 169,
					  x2: 1332,
					  y2: 431,
					  speaking_score: 2.349999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 60,
				  faces: [
					{
					  x1: 1072,
					  y1: 168,
					  x2: 1334,
					  y2: 431,
					  speaking_score: 2.516666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 61,
				  faces: [
					{
					  x1: 1072,
					  y1: 168,
					  x2: 1334,
					  y2: 431,
					  speaking_score: 2.650000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 62,
				  faces: [
					{
					  x1: 1071,
					  y1: 168,
					  x2: 1333,
					  y2: 431,
					  speaking_score: 2.850000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 63,
				  faces: [
					{
					  x1: 1070,
					  y1: 168,
					  x2: 1333,
					  y2: 431,
					  speaking_score: 3.116666674613953,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 64,
				  faces: [
					{
					  x1: 1070,
					  y1: 168,
					  x2: 1333,
					  y2: 431,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 65,
				  faces: [
					{
					  x1: 1070,
					  y1: 168,
					  x2: 1333,
					  y2: 430,
					  speaking_score: 3.783333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 66,
				  faces: [
					{
					  x1: 1070,
					  y1: 167,
					  x2: 1333,
					  y2: 430,
					  speaking_score: 3.916666626930237,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 67,
				  faces: [
					{
					  x1: 1071,
					  y1: 167,
					  x2: 1334,
					  y2: 430,
					  speaking_score: 4.016666611035665,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 68,
				  faces: [
					{
					  x1: 1071,
					  y1: 167,
					  x2: 1335,
					  y2: 430,
					  speaking_score: 4.066666603088379,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 69,
				  faces: [
					{
					  x1: 1072,
					  y1: 167,
					  x2: 1335,
					  y2: 430,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 70,
				  faces: [
					{
					  x1: 1073,
					  y1: 167,
					  x2: 1337,
					  y2: 431,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 71,
				  faces: [
					{
					  x1: 1078,
					  y1: 167,
					  x2: 1342,
					  y2: 431,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 72,
				  faces: [
					{
					  x1: 1083,
					  y1: 166,
					  x2: 1348,
					  y2: 431,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 73,
				  faces: [
					{
					  x1: 1083,
					  y1: 167,
					  x2: 1348,
					  y2: 431,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 74,
				  faces: [
					{
					  x1: 1087,
					  y1: 169,
					  x2: 1353,
					  y2: 435,
					  speaking_score: 4.049999952316284,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 75,
				  faces: [
					{
					  x1: 1091,
					  y1: 169,
					  x2: 1357,
					  y2: 435,
					  speaking_score: 3.966666618982951,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 76,
				  faces: [
					{
					  x1: 1092,
					  y1: 167,
					  x2: 1361,
					  y2: 437,
					  speaking_score: 3.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 77,
				  faces: [
					{
					  x1: 1094,
					  y1: 167,
					  x2: 1364,
					  y2: 437,
					  speaking_score: 3.733333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 78,
				  faces: [
					{
					  x1: 1096,
					  y1: 167,
					  x2: 1366,
					  y2: 437,
					  speaking_score: 3.600000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 79,
				  faces: [
					{
					  x1: 1096,
					  y1: 167,
					  x2: 1366,
					  y2: 437,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 80,
				  faces: [
					{
					  x1: 1096,
					  y1: 167,
					  x2: 1366,
					  y2: 437,
					  speaking_score: 3.416666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 81,
				  faces: [
					{
					  x1: 1096,
					  y1: 168,
					  x2: 1366,
					  y2: 437,
					  speaking_score: 3.350000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 82,
				  faces: [
					{
					  x1: 1097,
					  y1: 168,
					  x2: 1365,
					  y2: 437,
					  speaking_score: 3.350000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 83,
				  faces: [
					{
					  x1: 1097,
					  y1: 168,
					  x2: 1365,
					  y2: 437,
					  speaking_score: 3.350000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 84,
				  faces: [
					{
					  x1: 1097,
					  y1: 169,
					  x2: 1365,
					  y2: 436,
					  speaking_score: 3.383333365122477,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 85,
				  faces: [
					{
					  x1: 1097,
					  y1: 168,
					  x2: 1365,
					  y2: 436,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 86,
				  faces: [
					{
					  x1: 1097,
					  y1: 168,
					  x2: 1364,
					  y2: 435,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 87,
				  faces: [
					{
					  x1: 1094,
					  y1: 168,
					  x2: 1361,
					  y2: 435,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 88,
				  faces: [
					{
					  x1: 1092,
					  y1: 169,
					  x2: 1357,
					  y2: 434,
					  speaking_score: 3.316666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 89,
				  faces: [
					{
					  x1: 1090,
					  y1: 169,
					  x2: 1355,
					  y2: 434,
					  speaking_score: 3.216666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 90,
				  faces: [
					{
					  x1: 1090,
					  y1: 169,
					  x2: 1354,
					  y2: 434,
					  speaking_score: 3.150000055631002,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 91,
				  faces: [
					{
					  x1: 1090,
					  y1: 170,
					  x2: 1354,
					  y2: 434,
					  speaking_score: 3.133333404858907,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 92,
				  faces: [
					{
					  x1: 1090,
					  y1: 170,
					  x2: 1353,
					  y2: 433,
					  speaking_score: 3.116666714350382,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 93,
				  faces: [
					{
					  x1: 1090,
					  y1: 169,
					  x2: 1353,
					  y2: 433,
					  speaking_score: 3.033333381017049,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 94,
				  faces: [
					{
					  x1: 1090,
					  y1: 169,
					  x2: 1353,
					  y2: 433,
					  speaking_score: 2.783333361148834,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 95,
				  faces: [
					{
					  x1: 1090,
					  y1: 169,
					  x2: 1353,
					  y2: 433,
					  speaking_score: 2.533333341280619,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 96,
				  faces: [
					{
					  x1: 1089,
					  y1: 169,
					  x2: 1354,
					  y2: 434,
					  speaking_score: 2.216666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 97,
				  faces: [
					{
					  x1: 1089,
					  y1: 169,
					  x2: 1354,
					  y2: 434,
					  speaking_score: 1.883333305517833,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 98,
				  faces: [
					{
					  x1: 1089,
					  y1: 169,
					  x2: 1354,
					  y2: 434,
					  speaking_score: 1.549999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 99,
				  faces: [
					{
					  x1: 1092,
					  y1: 169,
					  x2: 1357,
					  y2: 434,
					  speaking_score: 1.266666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 100,
				  faces: [
					{
					  x1: 1096,
					  y1: 169,
					  x2: 1361,
					  y2: 434,
					  speaking_score: 1.166666656732559,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 101,
				  faces: [
					{
					  x1: 1098,
					  y1: 169,
					  x2: 1363,
					  y2: 434,
					  speaking_score: 1.066666662693024,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 102,
				  faces: [
					{
					  x1: 1098,
					  y1: 169,
					  x2: 1363,
					  y2: 434,
					  speaking_score: 0.950000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 103,
				  faces: [
					{
					  x1: 1098,
					  y1: 169,
					  x2: 1363,
					  y2: 435,
					  speaking_score: 0.8166666825612386,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 104,
				  faces: [
					{
					  x1: 1098,
					  y1: 169,
					  x2: 1363,
					  y2: 435,
					  speaking_score: 0.7500000099341074,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 105,
				  faces: [
					{
					  x1: 1098,
					  y1: 170,
					  x2: 1364,
					  y2: 435,
					  speaking_score: 0.7666666805744171,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 106,
				  faces: [
					{
					  x1: 1100,
					  y1: 170,
					  x2: 1365,
					  y2: 436,
					  speaking_score: 0.7833333412806193,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 107,
				  faces: [
					{
					  x1: 1100,
					  y1: 171,
					  x2: 1366,
					  y2: 437,
					  speaking_score: 0.8000000019868215,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 108,
				  faces: [
					{
					  x1: 1102,
					  y1: 173,
					  x2: 1368,
					  y2: 439,
					  speaking_score: 1.14999998609225,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 109,
				  faces: [
					{
					  x1: 1102,
					  y1: 173,
					  x2: 1368,
					  y2: 439,
					  speaking_score: 1.48333332935969,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 110,
				  faces: [
					{
					  x1: 1102,
					  y1: 173,
					  x2: 1368,
					  y2: 439,
					  speaking_score: 1.816666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 111,
				  faces: [
					{
					  x1: 1102,
					  y1: 173,
					  x2: 1369,
					  y2: 439,
					  speaking_score: 2.099999964237213,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 112,
				  faces: [
					{
					  x1: 1102,
					  y1: 173,
					  x2: 1369,
					  y2: 439,
					  speaking_score: 2.449999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 113,
				  faces: [
					{
					  x1: 1102,
					  y1: 172,
					  x2: 1369,
					  y2: 439,
					  speaking_score: 2.733333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 114,
				  faces: [
					{
					  x1: 1102,
					  y1: 171,
					  x2: 1369,
					  y2: 438,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 115,
				  faces: [
					{
					  x1: 1101,
					  y1: 170,
					  x2: 1368,
					  y2: 437,
					  speaking_score: 2.866666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 116,
				  faces: [
					{
					  x1: 1101,
					  y1: 170,
					  x2: 1368,
					  y2: 437,
					  speaking_score: 2.799999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 117,
				  faces: [
					{
					  x1: 1101,
					  y1: 170,
					  x2: 1368,
					  y2: 437,
					  speaking_score: 2.766666690508524,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 118,
				  faces: [
					{
					  x1: 1101,
					  y1: 170,
					  x2: 1368,
					  y2: 437,
					  speaking_score: 2.666666706403097,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 119,
				  faces: [
					{
					  x1: 1100,
					  y1: 170,
					  x2: 1367,
					  y2: 437,
					  speaking_score: 2.600000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 120,
				  faces: [
					{
					  x1: 1100,
					  y1: 170,
					  x2: 1367,
					  y2: 437,
					  speaking_score: 2.533333341280619,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 121,
				  faces: [
					{
					  x1: 1100,
					  y1: 170,
					  x2: 1367,
					  y2: 437,
					  speaking_score: 2.450000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 122,
				  faces: [
					{
					  x1: 1100,
					  y1: 171,
					  x2: 1367,
					  y2: 438,
					  speaking_score: 2.450000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 123,
				  faces: [
					{
					  x1: 1099,
					  y1: 173,
					  x2: 1366,
					  y2: 440,
					  speaking_score: 2.549999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 124,
				  faces: [
					{
					  x1: 1099,
					  y1: 175,
					  x2: 1366,
					  y2: 442,
					  speaking_score: 2.683333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 125,
				  faces: [
					{
					  x1: 1098,
					  y1: 176,
					  x2: 1365,
					  y2: 443,
					  speaking_score: 2.799999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 126,
				  faces: [
					{
					  x1: 1097,
					  y1: 176,
					  x2: 1364,
					  y2: 443,
					  speaking_score: 3,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 127,
				  faces: [
					{
					  x1: 1095,
					  y1: 177,
					  x2: 1362,
					  y2: 444,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 128,
				  faces: [
					{
					  x1: 1091,
					  y1: 177,
					  x2: 1360,
					  y2: 446,
					  speaking_score: 3.466666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 129,
				  faces: [
					{
					  x1: 1087,
					  y1: 177,
					  x2: 1357,
					  y2: 446,
					  speaking_score: 3.583333373069763,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 130,
				  faces: [
					{
					  x1: 1084,
					  y1: 176,
					  x2: 1355,
					  y2: 447,
					  speaking_score: 3.666666706403097,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 131,
				  faces: [
					{
					  x1: 1084,
					  y1: 176,
					  x2: 1355,
					  y2: 447,
					  speaking_score: 3.766666730244955,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 132,
				  faces: [
					{
					  x1: 1083,
					  y1: 176,
					  x2: 1355,
					  y2: 447,
					  speaking_score: 3.833333412806193,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 133,
				  faces: [
					{
					  x1: 1082,
					  y1: 175,
					  x2: 1353,
					  y2: 446,
					  speaking_score: 3.850000063578288,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 134,
				  faces: [
					{
					  x1: 1082,
					  y1: 174,
					  x2: 1353,
					  y2: 446,
					  speaking_score: 3.900000055631002,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 135,
				  faces: [
					{
					  x1: 1081,
					  y1: 174,
					  x2: 1352,
					  y2: 445,
					  speaking_score: 3.950000047683716,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 136,
				  faces: [
					{
					  x1: 1080,
					  y1: 172,
					  x2: 1351,
					  y2: 443,
					  speaking_score: 3.933333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 137,
				  faces: [
					{
					  x1: 1080,
					  y1: 169,
					  x2: 1351,
					  y2: 440,
					  speaking_score: 3.933333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 138,
				  faces: [
					{
					  x1: 1081,
					  y1: 168,
					  x2: 1350,
					  y2: 437,
					  speaking_score: 3.916666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 139,
				  faces: [
					{
					  x1: 1081,
					  y1: 166,
					  x2: 1350,
					  y2: 435,
					  speaking_score: 3.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 140,
				  faces: [
					{
					  x1: 1080,
					  y1: 164,
					  x2: 1349,
					  y2: 433,
					  speaking_score: 3.733333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 141,
				  faces: [
					{
					  x1: 1078,
					  y1: 163,
					  x2: 1347,
					  y2: 432,
					  speaking_score: 3.666666626930237,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 142,
				  faces: [
					{
					  x1: 1078,
					  y1: 163,
					  x2: 1346,
					  y2: 431,
					  speaking_score: 3.633333285649618,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 143,
				  faces: [
					{
					  x1: 1079,
					  y1: 164,
					  x2: 1345,
					  y2: 430,
					  speaking_score: 3.616666595141093,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 144,
				  faces: [
					{
					  x1: 1079,
					  y1: 163,
					  x2: 1345,
					  y2: 430,
					  speaking_score: 3.566666603088379,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 145,
				  faces: [
					{
					  x1: 1077,
					  y1: 162,
					  x2: 1346,
					  y2: 431,
					  speaking_score: 3.533333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 146,
				  faces: [
					{
					  x1: 1077,
					  y1: 160,
					  x2: 1346,
					  y2: 430,
					  speaking_score: 3.566666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 147,
				  faces: [
					{
					  x1: 1077,
					  y1: 159,
					  x2: 1346,
					  y2: 428,
					  speaking_score: 3.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 148,
				  faces: [
					{
					  x1: 1076,
					  y1: 157,
					  x2: 1346,
					  y2: 427,
					  speaking_score: 3.633333365122477,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 149,
				  faces: [
					{
					  x1: 1075,
					  y1: 157,
					  x2: 1345,
					  y2: 427,
					  speaking_score: 3.683333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 150,
				  faces: [
					{
					  x1: 1074,
					  y1: 158,
					  x2: 1344,
					  y2: 427,
					  speaking_score: 3.783333341280619,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 151,
				  faces: [
					{
					  x1: 1072,
					  y1: 158,
					  x2: 1342,
					  y2: 427,
					  speaking_score: 3.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 152,
				  faces: [
					{
					  x1: 1073,
					  y1: 159,
					  x2: 1340,
					  y2: 426,
					  speaking_score: 3.899999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 153,
				  faces: [
					{
					  x1: 1072,
					  y1: 159,
					  x2: 1339,
					  y2: 426,
					  speaking_score: 3.883333285649618,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 154,
				  faces: [
					{
					  x1: 1071,
					  y1: 159,
					  x2: 1338,
					  y2: 426,
					  speaking_score: 3.74999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 155,
				  faces: [
					{
					  x1: 1069,
					  y1: 160,
					  x2: 1336,
					  y2: 427,
					  speaking_score: 3.449999928474426,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 156,
				  faces: [
					{
					  x1: 1066,
					  y1: 163,
					  x2: 1332,
					  y2: 429,
					  speaking_score: 2.49999996026357,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 157,
				  faces: [
					{
					  x1: 1066,
					  y1: 164,
					  x2: 1332,
					  y2: 430,
					  speaking_score: 1.899999968707561,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 158,
				  faces: [
					{
					  x1: 1066,
					  y1: 167,
					  x2: 1331,
					  y2: 431,
					  speaking_score: 1.333333318432172,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 159,
				  faces: [
					{
					  x1: 1066,
					  y1: 169,
					  x2: 1331,
					  y2: 433,
					  speaking_score: 0.8833333353201548,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 160,
				  faces: [
					{
					  x1: 1067,
					  y1: 170,
					  x2: 1331,
					  y2: 434,
					  speaking_score: 0.550000011920929,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 161,
				  faces: [
					{
					  x1: 1067,
					  y1: 171,
					  x2: 1330,
					  y2: 434,
					  speaking_score: 0.316666675110658,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 162,
				  faces: [
					{
					  x1: 1067,
					  y1: 171,
					  x2: 1330,
					  y2: 435,
					  speaking_score: 0.3333333358168602,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 163,
				  faces: [
					{
					  x1: 1067,
					  y1: 171,
					  x2: 1331,
					  y2: 435,
					  speaking_score: 0.5166666607062022,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 164,
				  faces: [
					{
					  x1: 1069,
					  y1: 171,
					  x2: 1333,
					  y2: 435,
					  speaking_score: 0.9499999855955442,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 165,
				  faces: [
					{
					  x1: 1070,
					  y1: 171,
					  x2: 1334,
					  y2: 435,
					  speaking_score: 1.399999968707561,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 166,
				  faces: [
					{
					  x1: 1072,
					  y1: 171,
					  x2: 1335,
					  y2: 435,
					  speaking_score: 1.966666641334693,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 167,
				  faces: [
					{
					  x1: 1073,
					  y1: 171,
					  x2: 1337,
					  y2: 435,
					  speaking_score: 2.616666624943415,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 168,
				  faces: [
					{
					  x1: 1073,
					  y1: 170,
					  x2: 1338,
					  y2: 435,
					  speaking_score: 3.166666626930237,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 169,
				  faces: [
					{
					  x1: 1073,
					  y1: 170,
					  x2: 1339,
					  y2: 435,
					  speaking_score: 3.649999936421712,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 170,
				  faces: [
					{
					  x1: 1074,
					  y1: 169,
					  x2: 1339,
					  y2: 434,
					  speaking_score: 3.883333245913188,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 171,
				  faces: [
					{
					  x1: 1074,
					  y1: 167,
					  x2: 1339,
					  y2: 433,
					  speaking_score: 4.066666563351949,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 172,
				  faces: [
					{
					  x1: 1074,
					  y1: 167,
					  x2: 1340,
					  y2: 432,
					  speaking_score: 4.166666587193807,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 173,
				  faces: [
					{
					  x1: 1074,
					  y1: 165,
					  x2: 1341,
					  y2: 432,
					  speaking_score: 4.199999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 174,
				  faces: [
					{
					  x1: 1075,
					  y1: 164,
					  x2: 1342,
					  y2: 430,
					  speaking_score: 4.25,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 175,
				  faces: [
					{
					  x1: 1077,
					  y1: 162,
					  x2: 1343,
					  y2: 429,
					  speaking_score: 4.233333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 176,
				  faces: [
					{
					  x1: 1079,
					  y1: 160,
					  x2: 1347,
					  y2: 428,
					  speaking_score: 4.216666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 177,
				  faces: [
					{
					  x1: 1081,
					  y1: 158,
					  x2: 1350,
					  y2: 427,
					  speaking_score: 4.216666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 178,
				  faces: [
					{
					  x1: 1083,
					  y1: 158,
					  x2: 1352,
					  y2: 427,
					  speaking_score: 4.216666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 179,
				  faces: [
					{
					  x1: 1084,
					  y1: 158,
					  x2: 1353,
					  y2: 428,
					  speaking_score: 4.199999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 180,
				  faces: [
					{
					  x1: 1086,
					  y1: 158,
					  x2: 1355,
					  y2: 428,
					  speaking_score: 4.149999936421712,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 181,
				  faces: [
					{
					  x1: 1086,
					  y1: 158,
					  x2: 1355,
					  y2: 428,
					  speaking_score: 4.099999944368999,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 182,
				  faces: [
					{
					  x1: 1086,
					  y1: 158,
					  x2: 1355,
					  y2: 428,
					  speaking_score: 3.983333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 183,
				  faces: [
					{
					  x1: 1086,
					  y1: 159,
					  x2: 1355,
					  y2: 428,
					  speaking_score: 3.899999936421712,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 184,
				  faces: [
					{
					  x1: 1086,
					  y1: 161,
					  x2: 1355,
					  y2: 430,
					  speaking_score: 3.833333293596903,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 185,
				  faces: [
					{
					  x1: 1086,
					  y1: 163,
					  x2: 1355,
					  y2: 432,
					  speaking_score: 3.74999996026357,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 186,
				  faces: [
					{
					  x1: 1086,
					  y1: 164,
					  x2: 1355,
					  y2: 433,
					  speaking_score: 3.699999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 187,
				  faces: [
					{
					  x1: 1083,
					  y1: 165,
					  x2: 1352,
					  y2: 434,
					  speaking_score: 3.716666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 188,
				  faces: [
					{
					  x1: 1080,
					  y1: 165,
					  x2: 1349,
					  y2: 434,
					  speaking_score: 3.75,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 189,
				  faces: [
					{
					  x1: 1079,
					  y1: 165,
					  x2: 1349,
					  y2: 435,
					  speaking_score: 3.716666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 190,
				  faces: [
					{
					  x1: 1079,
					  y1: 166,
					  x2: 1349,
					  y2: 436,
					  speaking_score: 3.666666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 191,
				  faces: [
					{
					  x1: 1079,
					  y1: 166,
					  x2: 1349,
					  y2: 436,
					  speaking_score: 3.700000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 192,
				  faces: [
					{
					  x1: 1079,
					  y1: 166,
					  x2: 1349,
					  y2: 437,
					  speaking_score: 3.683333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 193,
				  faces: [
					{
					  x1: 1079,
					  y1: 166,
					  x2: 1349,
					  y2: 437,
					  speaking_score: 3.599999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 194,
				  faces: [
					{
					  x1: 1079,
					  y1: 167,
					  x2: 1350,
					  y2: 437,
					  speaking_score: 3.449999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 195,
				  faces: [
					{
					  x1: 1082,
					  y1: 167,
					  x2: 1353,
					  y2: 437,
					  speaking_score: 3.316666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 196,
				  faces: [
					{
					  x1: 1085,
					  y1: 167,
					  x2: 1356,
					  y2: 437,
					  speaking_score: 3.166666626930237,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 197,
				  faces: [
					{
					  x1: 1088,
					  y1: 167,
					  x2: 1359,
					  y2: 438,
					  speaking_score: 2.966666618982951,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 198,
				  faces: [
					{
					  x1: 1090,
					  y1: 168,
					  x2: 1361,
					  y2: 439,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 199,
				  faces: [
					{
					  x1: 1093,
					  y1: 171,
					  x2: 1365,
					  y2: 443,
					  speaking_score: 2.833333293596903,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 200,
				  faces: [
					{
					  x1: 1096,
					  y1: 174,
					  x2: 1368,
					  y2: 446,
					  speaking_score: 2.899999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 201,
				  faces: [
					{
					  x1: 1098,
					  y1: 175,
					  x2: 1370,
					  y2: 447,
					  speaking_score: 3.016666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 202,
				  faces: [
					{
					  x1: 1100,
					  y1: 176,
					  x2: 1372,
					  y2: 448,
					  speaking_score: 3.266666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 203,
				  faces: [
					{
					  x1: 1100,
					  y1: 176,
					  x2: 1372,
					  y2: 448,
					  speaking_score: 3.533333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 204,
				  faces: [
					{
					  x1: 1100,
					  y1: 177,
					  x2: 1372,
					  y2: 449,
					  speaking_score: 3.816666603088379,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 205,
				  faces: [
					{
					  x1: 1101,
					  y1: 177,
					  x2: 1372,
					  y2: 449,
					  speaking_score: 3.933333277702332,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 206,
				  faces: [
					{
					  x1: 1102,
					  y1: 179,
					  x2: 1372,
					  y2: 449,
					  speaking_score: 4.033333261807759,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 207,
				  faces: [
					{
					  x1: 1103,
					  y1: 179,
					  x2: 1372,
					  y2: 449,
					  speaking_score: 4.083333293596904,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 208,
				  faces: [
					{
					  x1: 1104,
					  y1: 180,
					  x2: 1372,
					  y2: 448,
					  speaking_score: 4.116666674613953,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 209,
				  faces: [
					{
					  x1: 1105,
					  y1: 180,
					  x2: 1373,
					  y2: 449,
					  speaking_score: 4.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 210,
				  faces: [
					{
					  x1: 1108,
					  y1: 182,
					  x2: 1374,
					  y2: 448,
					  speaking_score: 4.199999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 211,
				  faces: [
					{
					  x1: 1111,
					  y1: 184,
					  x2: 1376,
					  y2: 450,
					  speaking_score: 4.249999920527141,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 212,
				  faces: [
					{
					  x1: 1113,
					  y1: 187,
					  x2: 1377,
					  y2: 450,
					  speaking_score: 4.249999920527141,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 213,
				  faces: [
					{
					  x1: 1114,
					  y1: 187,
					  x2: 1378,
					  y2: 450,
					  speaking_score: 4.183333237965901,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 214,
				  faces: [
					{
					  x1: 1115,
					  y1: 187,
					  x2: 1379,
					  y2: 451,
					  speaking_score: 4.133333206176758,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 215,
				  faces: [
					{
					  x1: 1115,
					  y1: 188,
					  x2: 1379,
					  y2: 451,
					  speaking_score: 4.133333206176758,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 216,
				  faces: [
					{
					  x1: 1115,
					  y1: 188,
					  x2: 1379,
					  y2: 451,
					  speaking_score: 4.149999936421712,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 217,
				  faces: [
					{
					  x1: 1116,
					  y1: 188,
					  x2: 1379,
					  y2: 451,
					  speaking_score: 4.183333317438762,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 218,
				  faces: [
					{
					  x1: 1116,
					  y1: 188,
					  x2: 1378,
					  y2: 451,
					  speaking_score: 4.166666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 219,
				  faces: [
					{
					  x1: 1116,
					  y1: 188,
					  x2: 1378,
					  y2: 451,
					  speaking_score: 4.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 220,
				  faces: [
					{
					  x1: 1116,
					  y1: 188,
					  x2: 1378,
					  y2: 451,
					  speaking_score: 4.100000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 221,
				  faces: [
					{
					  x1: 1113,
					  y1: 188,
					  x2: 1376,
					  y2: 451,
					  speaking_score: 4.083333373069763,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 222,
				  faces: [
					{
					  x1: 1109,
					  y1: 188,
					  x2: 1372,
					  y2: 451,
					  speaking_score: 4.03333334128062,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 223,
				  faces: [
					{
					  x1: 1102,
					  y1: 188,
					  x2: 1365,
					  y2: 451,
					  speaking_score: 3.966666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 224,
				  faces: [
					{
					  x1: 1095,
					  y1: 188,
					  x2: 1358,
					  y2: 451,
					  speaking_score: 3.966666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 225,
				  faces: [
					{
					  x1: 1093,
					  y1: 187,
					  x2: 1356,
					  y2: 450,
					  speaking_score: 3.933333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 226,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1354,
					  y2: 449,
					  speaking_score: 3.816666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 227,
				  faces: [
					{
					  x1: 1089,
					  y1: 186,
					  x2: 1352,
					  y2: 449,
					  speaking_score: 3.549999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 228,
				  faces: [
					{
					  x1: 1083,
					  y1: 185,
					  x2: 1346,
					  y2: 447,
					  speaking_score: 2.516666663189729,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 229,
				  faces: [
					{
					  x1: 1080,
					  y1: 185,
					  x2: 1343,
					  y2: 447,
					  speaking_score: 1.733333331843217,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 230,
				  faces: [
					{
					  x1: 1074,
					  y1: 184,
					  x2: 1337,
					  y2: 447,
					  speaking_score: 0.9500000104308128,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 231,
				  faces: [
					{
					  x1: 1068,
					  y1: 184,
					  x2: 1331,
					  y2: 447,
					  speaking_score: 0.1499999985098839,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 232,
				  faces: [
					{
					  x1: 1063,
					  y1: 184,
					  x2: 1325,
					  y2: 446,
					  speaking_score: -0.5666666602094969,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 233,
				  faces: [
					{
					  x1: 1057,
					  y1: 184,
					  x2: 1320,
					  y2: 446,
					  speaking_score: -1.16666666418314,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 234,
				  faces: [
					{
					  x1: 1052,
					  y1: 184,
					  x2: 1315,
					  y2: 447,
					  speaking_score: -1.566666672627131,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 235,
				  faces: [
					{
					  x1: 1047,
					  y1: 184,
					  x2: 1311,
					  y2: 447,
					  speaking_score: -1.866666674613953,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 236,
				  faces: [
					{
					  x1: 1047,
					  y1: 183,
					  x2: 1311,
					  y2: 447,
					  speaking_score: -2.100000003973643,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 237,
				  faces: [
					{
					  x1: 1047,
					  y1: 183,
					  x2: 1311,
					  y2: 447,
					  speaking_score: -2.266666650772095,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 238,
				  faces: [
					{
					  x1: 1047,
					  y1: 183,
					  x2: 1311,
					  y2: 447,
					  speaking_score: -2.566666642824809,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 239,
				  faces: [
					{
					  x1: 1047,
					  y1: 183,
					  x2: 1311,
					  y2: 448,
					  speaking_score: -2.833333293596903,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 240,
				  faces: [
					{
					  x1: 1047,
					  y1: 184,
					  x2: 1311,
					  y2: 449,
					  speaking_score: -3.099999944368998,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 241,
				  faces: [
					{
					  x1: 1047,
					  y1: 184,
					  x2: 1311,
					  y2: 449,
					  speaking_score: -3.316666603088379,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 242,
				  faces: [
					{
					  x1: 1048,
					  y1: 185,
					  x2: 1313,
					  y2: 450,
					  speaking_score: -3.53333326180776,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 243,
				  faces: [
					{
					  x1: 1051,
					  y1: 186,
					  x2: 1315,
					  y2: 451,
					  speaking_score: -3.733333269755045,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 244,
				  faces: [
					{
					  x1: 1053,
					  y1: 187,
					  x2: 1318,
					  y2: 452,
					  speaking_score: -3.766666611035665,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 245,
				  faces: [
					{
					  x1: 1056,
					  y1: 188,
					  x2: 1321,
					  y2: 453,
					  speaking_score: -3.816666642824809,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 246,
				  faces: [
					{
					  x1: 1058,
					  y1: 190,
					  x2: 1324,
					  y2: 455,
					  speaking_score: -3.833333333333333,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 247,
				  faces: [
					{
					  x1: 1061,
					  y1: 191,
					  x2: 1327,
					  y2: 457,
					  speaking_score: -3.850000023841858,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 248,
				  faces: [
					{
					  x1: 1063,
					  y1: 191,
					  x2: 1329,
					  y2: 457,
					  speaking_score: -3.866666714350382,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 249,
				  faces: [
					{
					  x1: 1065,
					  y1: 191,
					  x2: 1331,
					  y2: 457,
					  speaking_score: -3.883333404858907,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 250,
				  faces: [
					{
					  x1: 1067,
					  y1: 191,
					  x2: 1333,
					  y2: 457,
					  speaking_score: -3.900000095367432,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 251,
				  faces: [
					{
					  x1: 1068,
					  y1: 191,
					  x2: 1335,
					  y2: 458,
					  speaking_score: -3.900000095367432,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 252,
				  faces: [
					{
					  x1: 1069,
					  y1: 191,
					  x2: 1337,
					  y2: 458,
					  speaking_score: -3.883333404858907,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 253,
				  faces: [
					{
					  x1: 1069,
					  y1: 190,
					  x2: 1337,
					  y2: 458,
					  speaking_score: -3.850000063578288,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 254,
				  faces: [
					{
					  x1: 1069,
					  y1: 190,
					  x2: 1337,
					  y2: 458,
					  speaking_score: -3.783333381017049,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 255,
				  faces: [
					{
					  x1: 1069,
					  y1: 190,
					  x2: 1337,
					  y2: 457,
					  speaking_score: -3.683333357175191,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 256,
				  faces: [
					{
					  x1: 1069,
					  y1: 189,
					  x2: 1337,
					  y2: 457,
					  speaking_score: -3.533333341280619,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 257,
				  faces: [
					{
					  x1: 1069,
					  y1: 189,
					  x2: 1337,
					  y2: 456,
					  speaking_score: -3.366666674613953,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 258,
				  faces: [
					{
					  x1: 1069,
					  y1: 188,
					  x2: 1337,
					  y2: 456,
					  speaking_score: -3.183333357175191,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 259,
				  faces: [
					{
					  x1: 1069,
					  y1: 188,
					  x2: 1336,
					  y2: 456,
					  speaking_score: -2.850000023841858,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 260,
				  faces: [
					{
					  x1: 1069,
					  y1: 188,
					  x2: 1337,
					  y2: 456,
					  speaking_score: -2.083333353201548,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 261,
				  faces: [
					{
					  x1: 1069,
					  y1: 188,
					  x2: 1337,
					  y2: 456,
					  speaking_score: -1.116666694482167,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 262,
				  faces: [
					{
					  x1: 1069,
					  y1: 188,
					  x2: 1337,
					  y2: 456,
					  speaking_score: -0.03333336114883423,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 263,
				  faces: [
					{
					  x1: 1069,
					  y1: 187,
					  x2: 1337,
					  y2: 455,
					  speaking_score: 1.133333305517833,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 264,
				  faces: [
					{
					  x1: 1068,
					  y1: 187,
					  x2: 1337,
					  y2: 455,
					  speaking_score: 2.283333281675974,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 265,
				  faces: [
					{
					  x1: 1068,
					  y1: 186,
					  x2: 1337,
					  y2: 455,
					  speaking_score: 3.283333321412405,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 266,
				  faces: [
					{
					  x1: 1068,
					  y1: 186,
					  x2: 1337,
					  y2: 455,
					  speaking_score: 3.833333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 267,
				  faces: [
					{
					  x1: 1068,
					  y1: 184,
					  x2: 1337,
					  y2: 453,
					  speaking_score: 4.166666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 268,
				  faces: [
					{
					  x1: 1068,
					  y1: 183,
					  x2: 1337,
					  y2: 452,
					  speaking_score: 4.283333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 269,
				  faces: [
					{
					  x1: 1068,
					  y1: 183,
					  x2: 1337,
					  y2: 452,
					  speaking_score: 4.25,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 270,
				  faces: [
					{
					  x1: 1068,
					  y1: 182,
					  x2: 1336,
					  y2: 450,
					  speaking_score: 4.200000047683716,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 271,
				  faces: [
					{
					  x1: 1068,
					  y1: 181,
					  x2: 1336,
					  y2: 449,
					  speaking_score: 4.150000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 272,
				  faces: [
					{
					  x1: 1068,
					  y1: 181,
					  x2: 1335,
					  y2: 449,
					  speaking_score: 4.083333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 273,
				  faces: [
					{
					  x1: 1066,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 274,
				  faces: [
					{
					  x1: 1066,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 3.966666698455811,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 275,
				  faces: [
					{
					  x1: 1067,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 276,
				  faces: [
					{
					  x1: 1067,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4.049999952316284,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 277,
				  faces: [
					{
					  x1: 1067,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4.049999952316284,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 278,
				  faces: [
					{
					  x1: 1066,
					  y1: 181,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 279,
				  faces: [
					{
					  x1: 1066,
					  y1: 182,
					  x2: 1334,
					  y2: 449,
					  speaking_score: 4.116666555404663,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 280,
				  faces: [
					{
					  x1: 1067,
					  y1: 182,
					  x2: 1334,
					  y2: 450,
					  speaking_score: 4.116666555404663,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 281,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1334,
					  y2: 451,
					  speaking_score: 4.116666555404663,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 282,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1335,
					  y2: 451,
					  speaking_score: 4.149999856948853,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 283,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1335,
					  y2: 452,
					  speaking_score: 4.149999856948853,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 284,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1335,
					  y2: 452,
					  speaking_score: 4.133333206176758,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 285,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1336,
					  y2: 453,
					  speaking_score: 4.083333253860474,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 286,
				  faces: [
					{
					  x1: 1067,
					  y1: 184,
					  x2: 1336,
					  y2: 453,
					  speaking_score: 4.016666611035665,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 287,
				  faces: [
					{
					  x1: 1067,
					  y1: 185,
					  x2: 1336,
					  y2: 454,
					  speaking_score: 3.983333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 288,
				  faces: [
					{
					  x1: 1067,
					  y1: 185,
					  x2: 1337,
					  y2: 455,
					  speaking_score: 3.933333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 289,
				  faces: [
					{
					  x1: 1066,
					  y1: 185,
					  x2: 1338,
					  y2: 456,
					  speaking_score: 3.916666706403097,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 290,
				  faces: [
					{
					  x1: 1066,
					  y1: 185,
					  x2: 1339,
					  y2: 458,
					  speaking_score: 3.866666714350382,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 291,
				  faces: [
					{
					  x1: 1066,
					  y1: 185,
					  x2: 1339,
					  y2: 459,
					  speaking_score: 3.833333373069763,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 292,
				  faces: [
					{
					  x1: 1067,
					  y1: 186,
					  x2: 1340,
					  y2: 459,
					  speaking_score: 3.883333365122477,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 293,
				  faces: [
					{
					  x1: 1068,
					  y1: 186,
					  x2: 1341,
					  y2: 459,
					  speaking_score: 3.866666714350382,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 294,
				  faces: [
					{
					  x1: 1069,
					  y1: 187,
					  x2: 1340,
					  y2: 458,
					  speaking_score: 3.833333373069763,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 295,
				  faces: [
					{
					  x1: 1069,
					  y1: 186,
					  x2: 1340,
					  y2: 458,
					  speaking_score: 3.800000031789144,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 296,
				  faces: [
					{
					  x1: 1069,
					  y1: 186,
					  x2: 1340,
					  y2: 458,
					  speaking_score: 3.783333381017049,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 297,
				  faces: [
					{
					  x1: 1069,
					  y1: 187,
					  x2: 1340,
					  y2: 458,
					  speaking_score: 3.75000003973643,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 298,
				  faces: [
					{
					  x1: 1069,
					  y1: 187,
					  x2: 1340,
					  y2: 458,
					  speaking_score: 3.683333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 299,
				  faces: [
					{
					  x1: 1070,
					  y1: 187,
					  x2: 1341,
					  y2: 458,
					  speaking_score: 3.633333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 300,
				  faces: [
					{
					  x1: 1075,
					  y1: 187,
					  x2: 1343,
					  y2: 456,
					  speaking_score: 3.616666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 301,
				  faces: [
					{
					  x1: 1079,
					  y1: 188,
					  x2: 1347,
					  y2: 456,
					  speaking_score: 3.583333293596903,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 302,
				  faces: [
					{
					  x1: 1083,
					  y1: 188,
					  x2: 1351,
					  y2: 456,
					  speaking_score: 3.516666611035665,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 303,
				  faces: [
					{
					  x1: 1087,
					  y1: 188,
					  x2: 1355,
					  y2: 456,
					  speaking_score: 3.366666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 304,
				  faces: [
					{
					  x1: 1091,
					  y1: 188,
					  x2: 1359,
					  y2: 456,
					  speaking_score: 3.199999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 305,
				  faces: [
					{
					  x1: 1093,
					  y1: 188,
					  x2: 1361,
					  y2: 456,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 306,
				  faces: [
					{
					  x1: 1097,
					  y1: 188,
					  x2: 1365,
					  y2: 456,
					  speaking_score: 3.049999952316284,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 307,
				  faces: [
					{
					  x1: 1099,
					  y1: 188,
					  x2: 1367,
					  y2: 456,
					  speaking_score: 3.099999944368998,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 308,
				  faces: [
					{
					  x1: 1101,
					  y1: 190,
					  x2: 1369,
					  y2: 458,
					  speaking_score: 3.233333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 309,
				  faces: [
					{
					  x1: 1103,
					  y1: 191,
					  x2: 1371,
					  y2: 459,
					  speaking_score: 3.399999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 310,
				  faces: [
					{
					  x1: 1104,
					  y1: 191,
					  x2: 1372,
					  y2: 459,
					  speaking_score: 3.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 311,
				  faces: [
					{
					  x1: 1106,
					  y1: 192,
					  x2: 1374,
					  y2: 460,
					  speaking_score: 3.75,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 312,
				  faces: [
					{
					  x1: 1107,
					  y1: 192,
					  x2: 1375,
					  y2: 460,
					  speaking_score: 3.800000031789144,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 313,
				  faces: [
					{
					  x1: 1107,
					  y1: 192,
					  x2: 1375,
					  y2: 460,
					  speaking_score: 3.833333373069763,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 314,
				  faces: [
					{
					  x1: 1107,
					  y1: 193,
					  x2: 1375,
					  y2: 461,
					  speaking_score: 3.850000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 315,
				  faces: [
					{
					  x1: 1107,
					  y1: 193,
					  x2: 1375,
					  y2: 460,
					  speaking_score: 3.866666674613953,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 316,
				  faces: [
					{
					  x1: 1107,
					  y1: 193,
					  x2: 1375,
					  y2: 461,
					  speaking_score: 3.849999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 317,
				  faces: [
					{
					  x1: 1108,
					  y1: 193,
					  x2: 1375,
					  y2: 461,
					  speaking_score: 3.766666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 318,
				  faces: [
					{
					  x1: 1108,
					  y1: 194,
					  x2: 1375,
					  y2: 460,
					  speaking_score: 3.566666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 319,
				  faces: [
					{
					  x1: 1108,
					  y1: 194,
					  x2: 1375,
					  y2: 461,
					  speaking_score: 3.133333305517832,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 320,
				  faces: [
					{
					  x1: 1108,
					  y1: 194,
					  x2: 1375,
					  y2: 461,
					  speaking_score: 2.449999971936146,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 321,
				  faces: [
					{
					  x1: 1108,
					  y1: 195,
					  x2: 1374,
					  y2: 461,
					  speaking_score: 1.699999981870254,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 322,
				  faces: [
					{
					  x1: 1107,
					  y1: 195,
					  x2: 1374,
					  y2: 462,
					  speaking_score: 0.9833333330849806,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 323,
				  faces: [
					{
					  x1: 1107,
					  y1: 196,
					  x2: 1374,
					  y2: 462,
					  speaking_score: 0.3500000076989333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 324,
				  faces: [
					{
					  x1: 1106,
					  y1: 196,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.5499999932944775,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 325,
				  faces: [
					{
					  x1: 1106,
					  y1: 196,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.6999999930461248,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 326,
				  faces: [
					{
					  x1: 1106,
					  y1: 196,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.7666666656732559,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 327,
				  faces: [
					{
					  x1: 1105,
					  y1: 196,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.8166666676600774,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 328,
				  faces: [
					{
					  x1: 1105,
					  y1: 196,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.8833333303531011,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 329,
				  faces: [
					{
					  x1: 1105,
					  y1: 195,
					  x2: 1373,
					  y2: 463,
					  speaking_score: -0.9166666666666666,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 330,
				  faces: [
					{
					  x1: 1105,
					  y1: 195,
					  x2: 1372,
					  y2: 463,
					  speaking_score: -0.8666666746139526,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 331,
				  faces: [
					{
					  x1: 1104,
					  y1: 195,
					  x2: 1372,
					  y2: 463,
					  speaking_score: -0.7833333412806193,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 332,
				  faces: [
					{
					  x1: 1104,
					  y1: 194,
					  x2: 1372,
					  y2: 463,
					  speaking_score: -0.4166666666666667,
					  active: false,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 333,
				  faces: [
					{
					  x1: 1104,
					  y1: 194,
					  x2: 1373,
					  y2: 463,
					  speaking_score: 0.2166666587193807,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 334,
				  faces: [
					{
					  x1: 1103,
					  y1: 193,
					  x2: 1372,
					  y2: 462,
					  speaking_score: 0.8833333055178324,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 335,
				  faces: [
					{
					  x1: 1102,
					  y1: 192,
					  x2: 1372,
					  y2: 463,
					  speaking_score: 1.49999996026357,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 336,
				  faces: [
					{
					  x1: 1101,
					  y1: 192,
					  x2: 1372,
					  y2: 462,
					  speaking_score: 2.116666615009308,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 337,
				  faces: [
					{
					  x1: 1101,
					  y1: 192,
					  x2: 1372,
					  y2: 462,
					  speaking_score: 2.783333281675974,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 338,
				  faces: [
					{
					  x1: 1100,
					  y1: 192,
					  x2: 1370,
					  y2: 462,
					  speaking_score: 3.149999936421712,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 339,
				  faces: [
					{
					  x1: 1098,
					  y1: 192,
					  x2: 1369,
					  y2: 462,
					  speaking_score: 3.233333269755045,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 340,
				  faces: [
					{
					  x1: 1096,
					  y1: 191,
					  x2: 1367,
					  y2: 462,
					  speaking_score: 3.283333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 341,
				  faces: [
					{
					  x1: 1096,
					  y1: 191,
					  x2: 1367,
					  y2: 462,
					  speaking_score: 3.383333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 342,
				  faces: [
					{
					  x1: 1095,
					  y1: 191,
					  x2: 1366,
					  y2: 462,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 343,
				  faces: [
					{
					  x1: 1094,
					  y1: 191,
					  x2: 1365,
					  y2: 462,
					  speaking_score: 3.566666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 344,
				  faces: [
					{
					  x1: 1093,
					  y1: 190,
					  x2: 1363,
					  y2: 460,
					  speaking_score: 3.600000023841858,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 345,
				  faces: [
					{
					  x1: 1093,
					  y1: 189,
					  x2: 1363,
					  y2: 459,
					  speaking_score: 3.50000003973643,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 346,
				  faces: [
					{
					  x1: 1094,
					  y1: 189,
					  x2: 1363,
					  y2: 458,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 347,
				  faces: [
					{
					  x1: 1094,
					  y1: 189,
					  x2: 1362,
					  y2: 458,
					  speaking_score: 3.000000019868215,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 348,
				  faces: [
					{
					  x1: 1093,
					  y1: 190,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 2.649999996026357,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 349,
				  faces: [
					{
					  x1: 1093,
					  y1: 190,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 2.600000003973643,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 350,
				  faces: [
					{
					  x1: 1093,
					  y1: 190,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 2.683333337306976,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 351,
				  faces: [
					{
					  x1: 1093,
					  y1: 190,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 2.916666646798452,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 352,
				  faces: [
					{
					  x1: 1092,
					  y1: 190,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 3.25,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 353,
				  faces: [
					{
					  x1: 1092,
					  y1: 189,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 354,
				  faces: [
					{
					  x1: 1092,
					  y1: 189,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 355,
				  faces: [
					{
					  x1: 1091,
					  y1: 189,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 3.516666690508524,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 356,
				  faces: [
					{
					  x1: 1091,
					  y1: 191,
					  x2: 1362,
					  y2: 462,
					  speaking_score: 3.633333365122477,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 357,
				  faces: [
					{
					  x1: 1090,
					  y1: 191,
					  x2: 1362,
					  y2: 462,
					  speaking_score: 3.683333396911621,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 358,
				  faces: [
					{
					  x1: 1090,
					  y1: 191,
					  x2: 1362,
					  y2: 462,
					  speaking_score: 3.550000031789144,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 359,
				  faces: [
					{
					  x1: 1090,
					  y1: 190,
					  x2: 1362,
					  y2: 462,
					  speaking_score: 3.450000047683716,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 360,
				  faces: [
					{
					  x1: 1090,
					  y1: 190,
					  x2: 1362,
					  y2: 462,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 361,
				  faces: [
					{
					  x1: 1090,
					  y1: 188,
					  x2: 1362,
					  y2: 460,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 362,
				  faces: [
					{
					  x1: 1090,
					  y1: 188,
					  x2: 1362,
					  y2: 460,
					  speaking_score: 3.349999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 363,
				  faces: [
					{
					  x1: 1090,
					  y1: 189,
					  x2: 1362,
					  y2: 460,
					  speaking_score: 3.266666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 364,
				  faces: [
					{
					  x1: 1090,
					  y1: 189,
					  x2: 1361,
					  y2: 460,
					  speaking_score: 3.266666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 365,
				  faces: [
					{
					  x1: 1090,
					  y1: 188,
					  x2: 1362,
					  y2: 459,
					  speaking_score: 3.283333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 366,
				  faces: [
					{
					  x1: 1091,
					  y1: 188,
					  x2: 1361,
					  y2: 459,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 367,
				  faces: [
					{
					  x1: 1091,
					  y1: 188,
					  x2: 1361,
					  y2: 458,
					  speaking_score: 3.366666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 368,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 458,
					  speaking_score: 3.366666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 369,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 458,
					  speaking_score: 3.349999944368998,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 370,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 458,
					  speaking_score: 3.399999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 371,
				  faces: [
					{
					  x1: 1092,
					  y1: 188,
					  x2: 1362,
					  y2: 458,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 372,
				  faces: [
					{
					  x1: 1092,
					  y1: 188,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 373,
				  faces: [
					{
					  x1: 1092,
					  y1: 188,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 374,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 375,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 376,
				  faces: [
					{
					  x1: 1091,
					  y1: 186,
					  x2: 1362,
					  y2: 457,
					  speaking_score: 3.25,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 377,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 457,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 378,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 457,
					  speaking_score: 3.099999984105428,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 379,
				  faces: [
					{
					  x1: 1091,
					  y1: 187,
					  x2: 1362,
					  y2: 457,
					  speaking_score: 3.116666634877523,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 380,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 381,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 457,
					  speaking_score: 3.149999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 382,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 456,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 383,
				  faces: [
					{
					  x1: 1092,
					  y1: 187,
					  x2: 1361,
					  y2: 455,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 384,
				  faces: [
					{
					  x1: 1092,
					  y1: 186,
					  x2: 1361,
					  y2: 454,
					  speaking_score: 3.166666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 385,
				  faces: [
					{
					  x1: 1092,
					  y1: 186,
					  x2: 1361,
					  y2: 454,
					  speaking_score: 3.166666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 386,
				  faces: [
					{
					  x1: 1093,
					  y1: 186,
					  x2: 1361,
					  y2: 453,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 387,
				  faces: [
					{
					  x1: 1094,
					  y1: 186,
					  x2: 1360,
					  y2: 453,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 388,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 389,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 390,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 3.083333293596903,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 391,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 2.949999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 392,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 2.766666650772095,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 393,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 2.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 394,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 2.450000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 395,
				  faces: [
					{
					  x1: 1095,
					  y1: 186,
					  x2: 1361,
					  y2: 452,
					  speaking_score: 2.400000015894572,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 396,
				  faces: [
					{
					  x1: 1094,
					  y1: 187,
					  x2: 1361,
					  y2: 454,
					  speaking_score: 2.483333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 397,
				  faces: [
					{
					  x1: 1094,
					  y1: 187,
					  x2: 1361,
					  y2: 454,
					  speaking_score: 2.716666658719381,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 398,
				  faces: [
					{
					  x1: 1094,
					  y1: 187,
					  x2: 1361,
					  y2: 454,
					  speaking_score: 2.983333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 399,
				  faces: [
					{
					  x1: 1092,
					  y1: 186,
					  x2: 1363,
					  y2: 456,
					  speaking_score: 3.233333309491476,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 400,
				  faces: [
					{
					  x1: 1092,
					  y1: 186,
					  x2: 1363,
					  y2: 456,
					  speaking_score: 3.433333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 401,
				  faces: [
					{
					  x1: 1093,
					  y1: 186,
					  x2: 1363,
					  y2: 456,
					  speaking_score: 3.583333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 402,
				  faces: [
					{
					  x1: 1093,
					  y1: 185,
					  x2: 1364,
					  y2: 457,
					  speaking_score: 3.666666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 403,
				  faces: [
					{
					  x1: 1093,
					  y1: 185,
					  x2: 1364,
					  y2: 457,
					  speaking_score: 3.666666666666667,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 404,
				  faces: [
					{
					  x1: 1093,
					  y1: 185,
					  x2: 1364,
					  y2: 456,
					  speaking_score: 3.633333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 405,
				  faces: [
					{
					  x1: 1093,
					  y1: 185,
					  x2: 1364,
					  y2: 456,
					  speaking_score: 3.583333293596903,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 406,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1364,
					  y2: 456,
					  speaking_score: 3.433333277702332,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 407,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.299999952316284,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 408,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.183333277702332,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 409,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.099999944368998,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 410,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.016666611035665,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 411,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 2.899999976158142,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 412,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 2.949999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 413,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.033333301544189,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 414,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 415,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 416,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1365,
					  y2: 454,
					  speaking_score: 3.083333333333333,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 417,
				  faces: [
					{
					  x1: 1094,
					  y1: 183,
					  x2: 1364,
					  y2: 454,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 418,
				  faces: [
					{
					  x1: 1094,
					  y1: 183,
					  x2: 1364,
					  y2: 454,
					  speaking_score: 2.950000007947286,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 419,
				  faces: [
					{
					  x1: 1094,
					  y1: 183,
					  x2: 1364,
					  y2: 454,
					  speaking_score: 2.933333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 420,
				  faces: [
					{
					  x1: 1094,
					  y1: 183,
					  x2: 1364,
					  y2: 454,
					  speaking_score: 2.816666642824809,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 421,
				  faces: [
					{
					  x1: 1094,
					  y1: 184,
					  x2: 1364,
					  y2: 454,
					  speaking_score: 2.799999992052714,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 422,
				  faces: [
					{
					  x1: 1093,
					  y1: 183,
					  x2: 1365,
					  y2: 455,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 423,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1365,
					  y2: 456,
					  speaking_score: 2.933333317438761,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 424,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1365,
					  y2: 456,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 425,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1365,
					  y2: 456,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 426,
				  faces: [
					{
					  x1: 1093,
					  y1: 184,
					  x2: 1364,
					  y2: 456,
					  speaking_score: 2.740000009536743,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 427,
				  faces: [
					{
					  x1: 1092,
					  y1: 183,
					  x2: 1364,
					  y2: 455,
					  speaking_score: 2.75,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 428,
				  faces: [
					{
					  x1: 1092,
					  y1: 183,
					  x2: 1363,
					  y2: 455,
					  speaking_score: 2.699999968210856,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 429,
				  faces: [
					{
					  x1: 1091,
					  y1: 183,
					  x2: 1363,
					  y2: 455,
					  speaking_score: 2.5,
					  active: true,
					  track_id: 0,
					},
				  ],
				},
				{
				  frame_number: 430,
				  faces: [
				  ],
				},
				{
				  frame_number: 431,
				  faces: [
				  ],
				},
				{
				  frame_number: 432,
				  faces: [
				  ],
				},
				{
				  frame_number: 433,
				  faces: [
				  ],
				},
				{
				  frame_number: 434,
				  faces: [
				  ],
				},
				{
				  frame_number: 435,
				  faces: [
				  ],
				},
				{
				  frame_number: 436,
				  faces: [
				  ],
				},
				{
				  frame_number: 437,
				  faces: [
				  ],
				},
				{
				  frame_number: 438,
				  faces: [
				  ],
				},
				{
				  frame_number: 439,
				  faces: [
				  ],
				},
				{
				  frame_number: 440,
				  faces: [
				  ],
				},
				{
				  frame_number: 441,
				  faces: [
				  ],
				},
				{
				  frame_number: 442,
				  faces: [
				  ],
				},
				{
				  frame_number: 443,
				  faces: [
				  ],
				},
				{
				  frame_number: 444,
				  faces: [
					{
					  x1: 592,
					  y1: 178,
					  x2: 827,
					  y2: 412,
					  speaking_score: 2.166666666666667,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 445,
				  faces: [
					{
					  x1: 594,
					  y1: 178,
					  x2: 835,
					  y2: 419,
					  speaking_score: 2.375,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 446,
				  faces: [
					{
					  x1: 595,
					  y1: 178,
					  x2: 839,
					  y2: 421,
					  speaking_score: 2.459999990463257,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 447,
				  faces: [
					{
					  x1: 599,
					  y1: 178,
					  x2: 845,
					  y2: 423,
					  speaking_score: 2.483333309491476,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 448,
				  faces: [
					{
					  x1: 605,
					  y1: 178,
					  x2: 851,
					  y2: 423,
					  speaking_score: 2.566666642824809,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 449,
				  faces: [
					{
					  x1: 609,
					  y1: 178,
					  x2: 854,
					  y2: 423,
					  speaking_score: 2.599999984105428,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 450,
				  faces: [
					{
					  x1: 612,
					  y1: 178,
					  x2: 857,
					  y2: 423,
					  speaking_score: 2.599999984105428,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 451,
				  faces: [
					{
					  x1: 613,
					  y1: 178,
					  x2: 858,
					  y2: 423,
					  speaking_score: 2.5,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 452,
				  faces: [
					{
					  x1: 614,
					  y1: 178,
					  x2: 859,
					  y2: 423,
					  speaking_score: 2.433333357175191,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 453,
				  faces: [
					{
					  x1: 616,
					  y1: 179,
					  x2: 859,
					  y2: 422,
					  speaking_score: 2.400000055631002,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 454,
				  faces: [
					{
					  x1: 616,
					  y1: 178,
					  x2: 859,
					  y2: 421,
					  speaking_score: 2.433333396911621,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 455,
				  faces: [
					{
					  x1: 617,
					  y1: 179,
					  x2: 858,
					  y2: 420,
					  speaking_score: 2.483333388964335,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 456,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.600000063578288,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 457,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.666666706403097,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 458,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 459,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.766666650772095,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 460,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.716666658719381,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 461,
				  faces: [
					{
					  x1: 617,
					  y1: 177,
					  x2: 859,
					  y2: 419,
					  speaking_score: 2.666666666666667,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 462,
				  faces: [
					{
					  x1: 616,
					  y1: 177,
					  x2: 858,
					  y2: 419,
					  speaking_score: 2.583333333333333,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 463,
				  faces: [
					{
					  x1: 614,
					  y1: 177,
					  x2: 856,
					  y2: 419,
					  speaking_score: 2.533333341280619,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 464,
				  faces: [
					{
					  x1: 612,
					  y1: 177,
					  x2: 854,
					  y2: 419,
					  speaking_score: 2.450000007947286,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 465,
				  faces: [
					{
					  x1: 608,
					  y1: 176,
					  x2: 851,
					  y2: 419,
					  speaking_score: 2.416666706403097,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 466,
				  faces: [
					{
					  x1: 605,
					  y1: 176,
					  x2: 849,
					  y2: 420,
					  speaking_score: 2.433333357175191,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 467,
				  faces: [
					{
					  x1: 603,
					  y1: 176,
					  x2: 847,
					  y2: 420,
					  speaking_score: 2.416666666666667,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 468,
				  faces: [
					{
					  x1: 600,
					  y1: 176,
					  x2: 846,
					  y2: 422,
					  speaking_score: 2.283333321412405,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 469,
				  faces: [
					{
					  x1: 598,
					  y1: 176,
					  x2: 847,
					  y2: 424,
					  speaking_score: 2.23333332935969,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 470,
				  faces: [
					{
					  x1: 598,
					  y1: 177,
					  x2: 847,
					  y2: 425,
					  speaking_score: 2.199999988079071,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 471,
				  faces: [
					{
					  x1: 597,
					  y1: 176,
					  x2: 846,
					  y2: 426,
					  speaking_score: 2.116666654745738,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 472,
				  faces: [
					{
					  x1: 595,
					  y1: 177,
					  x2: 844,
					  y2: 427,
					  speaking_score: 2.100000003973643,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 473,
				  faces: [
					{
					  x1: 592,
					  y1: 178,
					  x2: 842,
					  y2: 427,
					  speaking_score: 2.116666694482168,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 474,
				  faces: [
					{
					  x1: 588,
					  y1: 178,
					  x2: 838,
					  y2: 428,
					  speaking_score: 2.166666706403097,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 475,
				  faces: [
					{
					  x1: 585,
					  y1: 179,
					  x2: 836,
					  y2: 429,
					  speaking_score: 2.183333357175191,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 476,
				  faces: [
					{
					  x1: 583,
					  y1: 181,
					  x2: 834,
					  y2: 432,
					  speaking_score: 2.183333357175191,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 477,
				  faces: [
					{
					  x1: 580,
					  y1: 185,
					  x2: 836,
					  y2: 440,
					  speaking_score: 2.233333349227905,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 478,
				  faces: [
					{
					  x1: 580,
					  y1: 193,
					  x2: 836,
					  y2: 448,
					  speaking_score: 2.299999992052714,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 479,
				  faces: [
					{
					  x1: 580,
					  y1: 198,
					  x2: 836,
					  y2: 453,
					  speaking_score: 2.333333293596903,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 480,
				  faces: [
					{
					  x1: 580,
					  y1: 204,
					  x2: 836,
					  y2: 459,
					  speaking_score: 2.399999936421712,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 481,
				  faces: [
					{
					  x1: 580,
					  y1: 203,
					  x2: 836,
					  y2: 459,
					  speaking_score: 2.49999996026357,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 482,
				  faces: [
					{
					  x1: 580,
					  y1: 207,
					  x2: 836,
					  y2: 463,
					  speaking_score: 2.616666634877523,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 483,
				  faces: [
					{
					  x1: 579,
					  y1: 207,
					  x2: 837,
					  y2: 464,
					  speaking_score: 2.716666658719381,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 484,
				  faces: [
					{
					  x1: 581,
					  y1: 207,
					  x2: 838,
					  y2: 464,
					  speaking_score: 2.716666658719381,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 485,
				  faces: [
					{
					  x1: 584,
					  y1: 207,
					  x2: 841,
					  y2: 464,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 486,
				  faces: [
					{
					  x1: 588,
					  y1: 206,
					  x2: 845,
					  y2: 464,
					  speaking_score: 2.716666698455811,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 487,
				  faces: [
					{
					  x1: 590,
					  y1: 206,
					  x2: 847,
					  y2: 464,
					  speaking_score: 2.716666698455811,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 488,
				  faces: [
					{
					  x1: 590,
					  y1: 206,
					  x2: 847,
					  y2: 464,
					  speaking_score: 2.700000007947286,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 489,
				  faces: [
					{
					  x1: 590,
					  y1: 205,
					  x2: 847,
					  y2: 463,
					  speaking_score: 2.683333317438761,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 490,
				  faces: [
					{
					  x1: 590,
					  y1: 204,
					  x2: 847,
					  y2: 461,
					  speaking_score: 2.700000007947286,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 491,
				  faces: [
					{
					  x1: 590,
					  y1: 201,
					  x2: 847,
					  y2: 459,
					  speaking_score: 2.633333325386047,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 492,
				  faces: [
					{
					  x1: 589,
					  y1: 196,
					  x2: 847,
					  y2: 454,
					  speaking_score: 2.549999992052714,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 493,
				  faces: [
					{
					  x1: 589,
					  y1: 193,
					  x2: 846,
					  y2: 451,
					  speaking_score: 2.483333349227905,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 494,
				  faces: [
					{
					  x1: 587,
					  y1: 192,
					  x2: 845,
					  y2: 449,
					  speaking_score: 2.416666706403097,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 495,
				  faces: [
					{
					  x1: 586,
					  y1: 191,
					  x2: 843,
					  y2: 449,
					  speaking_score: 2.333333373069763,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 496,
				  faces: [
					{
					  x1: 584,
					  y1: 191,
					  x2: 842,
					  y2: 448,
					  speaking_score: 2.316666722297668,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 497,
				  faces: [
					{
					  x1: 583,
					  y1: 190,
					  x2: 840,
					  y2: 448,
					  speaking_score: 2.300000031789144,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 498,
				  faces: [
					{
					  x1: 581,
					  y1: 190,
					  x2: 839,
					  y2: 447,
					  speaking_score: 2.316666722297668,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 499,
				  faces: [
					{
					  x1: 580,
					  y1: 190,
					  x2: 836,
					  y2: 447,
					  speaking_score: 2.283333381017049,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 500,
				  faces: [
					{
					  x1: 578,
					  y1: 190,
					  x2: 835,
					  y2: 446,
					  speaking_score: 2.266666690508524,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 501,
				  faces: [
					{
					  x1: 577,
					  y1: 189,
					  x2: 832,
					  y2: 445,
					  speaking_score: 2.316666682561239,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 502,
				  faces: [
					{
					  x1: 576,
					  y1: 190,
					  x2: 827,
					  y2: 441,
					  speaking_score: 2.383333325386047,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 503,
				  faces: [
					{
					  x1: 575,
					  y1: 189,
					  x2: 825,
					  y2: 439,
					  speaking_score: 2.433333317438761,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 504,
				  faces: [
					{
					  x1: 573,
					  y1: 188,
					  x2: 823,
					  y2: 439,
					  speaking_score: 2.49999996026357,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 505,
				  faces: [
					{
					  x1: 573,
					  y1: 189,
					  x2: 823,
					  y2: 438,
					  speaking_score: 2.616666634877523,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 506,
				  faces: [
					{
					  x1: 574,
					  y1: 186,
					  x2: 822,
					  y2: 435,
					  speaking_score: 2.699999968210856,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 507,
				  faces: [
					{
					  x1: 574,
					  y1: 183,
					  x2: 822,
					  y2: 432,
					  speaking_score: 2.74999996026357,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 508,
				  faces: [
					{
					  x1: 575,
					  y1: 184,
					  x2: 821,
					  y2: 429,
					  speaking_score: 2.783333301544189,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 509,
				  faces: [
					{
					  x1: 575,
					  y1: 184,
					  x2: 821,
					  y2: 429,
					  speaking_score: 2.816666642824809,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 510,
				  faces: [
					{
					  x1: 575,
					  y1: 184,
					  x2: 821,
					  y2: 429,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 511,
				  faces: [
					{
					  x1: 576,
					  y1: 184,
					  x2: 821,
					  y2: 429,
					  speaking_score: 2.833333293596903,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 512,
				  faces: [
					{
					  x1: 576,
					  y1: 184,
					  x2: 822,
					  y2: 429,
					  speaking_score: 2.866666634877523,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 513,
				  faces: [
					{
					  x1: 576,
					  y1: 184,
					  x2: 822,
					  y2: 429,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 514,
				  faces: [
					{
					  x1: 577,
					  y1: 183,
					  x2: 822,
					  y2: 429,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 515,
				  faces: [
					{
					  x1: 577,
					  y1: 183,
					  x2: 823,
					  y2: 429,
					  speaking_score: 2.633333345254262,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 516,
				  faces: [
					{
					  x1: 578,
					  y1: 182,
					  x2: 826,
					  y2: 431,
					  speaking_score: 2.400000015894572,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 517,
				  faces: [
					{
					  x1: 578,
					  y1: 182,
					  x2: 827,
					  y2: 431,
					  speaking_score: 2.283333341280619,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 518,
				  faces: [
					{
					  x1: 579,
					  y1: 184,
					  x2: 829,
					  y2: 433,
					  speaking_score: 2.216666658719381,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 519,
				  faces: [
					{
					  x1: 579,
					  y1: 185,
					  x2: 831,
					  y2: 437,
					  speaking_score: 2.199999968210856,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 520,
				  faces: [
					{
					  x1: 579,
					  y1: 185,
					  x2: 832,
					  y2: 438,
					  speaking_score: 2.216666638851166,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 521,
				  faces: [
					{
					  x1: 581,
					  y1: 185,
					  x2: 834,
					  y2: 439,
					  speaking_score: 2.183333317438761,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 522,
				  faces: [
					{
					  x1: 582,
					  y1: 186,
					  x2: 835,
					  y2: 439,
					  speaking_score: 2.066666642824809,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 523,
				  faces: [
					{
					  x1: 581,
					  y1: 185,
					  x2: 837,
					  y2: 441,
					  speaking_score: 1.949999988079071,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 524,
				  faces: [
					{
					  x1: 581,
					  y1: 185,
					  x2: 838,
					  y2: 442,
					  speaking_score: 1.783333321412404,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 525,
				  faces: [
					{
					  x1: 582,
					  y1: 185,
					  x2: 839,
					  y2: 442,
					  speaking_score: 1.566666662693024,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 526,
				  faces: [
					{
					  x1: 582,
					  y1: 185,
					  x2: 839,
					  y2: 443,
					  speaking_score: 1.383333325386047,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 527,
				  faces: [
					{
					  x1: 582,
					  y1: 186,
					  x2: 840,
					  y2: 443,
					  speaking_score: 1.283333321412404,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 528,
				  faces: [
					{
					  x1: 583,
					  y1: 187,
					  x2: 841,
					  y2: 445,
					  speaking_score: 1.316666662693024,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 529,
				  faces: [
					{
					  x1: 583,
					  y1: 187,
					  x2: 841,
					  y2: 445,
					  speaking_score: 1.5,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 530,
				  faces: [
					{
					  x1: 583,
					  y1: 189,
					  x2: 841,
					  y2: 447,
					  speaking_score: 1.799999992052714,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 531,
				  faces: [
					{
					  x1: 583,
					  y1: 189,
					  x2: 841,
					  y2: 447,
					  speaking_score: 2.116666674613953,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 532,
				  faces: [
					{
					  x1: 583,
					  y1: 189,
					  x2: 842,
					  y2: 448,
					  speaking_score: 2.416666686534882,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 533,
				  faces: [
					{
					  x1: 582,
					  y1: 188,
					  x2: 842,
					  y2: 449,
					  speaking_score: 2.716666698455811,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 534,
				  faces: [
					{
					  x1: 582,
					  y1: 188,
					  x2: 842,
					  y2: 449,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 535,
				  faces: [
					{
					  x1: 582,
					  y1: 188,
					  x2: 842,
					  y2: 449,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 536,
				  faces: [
					{
					  x1: 581,
					  y1: 188,
					  x2: 842,
					  y2: 449,
					  speaking_score: 2.783333381017049,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 537,
				  faces: [
					{
					  x1: 581,
					  y1: 189,
					  x2: 840,
					  y2: 448,
					  speaking_score: 2.800000031789144,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 538,
				  faces: [
					{
					  x1: 581,
					  y1: 189,
					  x2: 840,
					  y2: 447,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 539,
				  faces: [
					{
					  x1: 581,
					  y1: 189,
					  x2: 839,
					  y2: 447,
					  speaking_score: 2.566666662693024,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 540,
				  faces: [
					{
					  x1: 580,
					  y1: 189,
					  x2: 837,
					  y2: 446,
					  speaking_score: 2.3,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 541,
				  faces: [
					{
					  x1: 580,
					  y1: 189,
					  x2: 837,
					  y2: 445,
					  speaking_score: 2.149999976158142,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 542,
				  faces: [
					{
					  x1: 581,
					  y1: 189,
					  x2: 836,
					  y2: 444,
					  speaking_score: 1.866666634877523,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 543,
				  faces: [
					{
					  x1: 581,
					  y1: 190,
					  x2: 835,
					  y2: 444,
					  speaking_score: 1.5,
					  active: true,
					  track_id: 1,
					},
				  ],
				},
				{
				  frame_number: 544,
				  faces: [
				  ],
				},
				{
				  frame_number: 545,
				  faces: [
					{
					  x1: 512,
					  y1: 154,
					  x2: 1021,
					  y2: 663,
					  speaking_score: 2.799999952316284,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 546,
				  faces: [
					{
					  x1: 511,
					  y1: 154,
					  x2: 1022,
					  y2: 664,
					  speaking_score: 2.924999952316284,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 547,
				  faces: [
					{
					  x1: 511,
					  y1: 155,
					  x2: 1022,
					  y2: 666,
					  speaking_score: 2.959999942779541,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 548,
				  faces: [
					{
					  x1: 508,
					  y1: 151,
					  x2: 1025,
					  y2: 669,
					  speaking_score: 2.966666618982951,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 549,
				  faces: [
					{
					  x1: 508,
					  y1: 151,
					  x2: 1025,
					  y2: 669,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 550,
				  faces: [
					{
					  x1: 508,
					  y1: 151,
					  x2: 1025,
					  y2: 669,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 551,
				  faces: [
					{
					  x1: 508,
					  y1: 151,
					  x2: 1025,
					  y2: 669,
					  speaking_score: 3.283333301544189,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 552,
				  faces: [
					{
					  x1: 507,
					  y1: 150,
					  x2: 1024,
					  y2: 667,
					  speaking_score: 3.333333293596903,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 553,
				  faces: [
					{
					  x1: 507,
					  y1: 150,
					  x2: 1024,
					  y2: 667,
					  speaking_score: 3.416666626930237,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 554,
				  faces: [
					{
					  x1: 507,
					  y1: 150,
					  x2: 1024,
					  y2: 667,
					  speaking_score: 3.516666611035665,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 555,
				  faces: [
					{
					  x1: 507,
					  y1: 151,
					  x2: 1025,
					  y2: 669,
					  speaking_score: 3.549999952316284,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 556,
				  faces: [
					{
					  x1: 506,
					  y1: 151,
					  x2: 1025,
					  y2: 670,
					  speaking_score: 3.466666618982951,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 557,
				  faces: [
					{
					  x1: 506,
					  y1: 151,
					  x2: 1025,
					  y2: 670,
					  speaking_score: 3.299999952316284,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 558,
				  faces: [
					{
					  x1: 506,
					  y1: 149,
					  x2: 1025,
					  y2: 668,
					  speaking_score: 3.116666634877523,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 559,
				  faces: [
					{
					  x1: 508,
					  y1: 149,
					  x2: 1025,
					  y2: 666,
					  speaking_score: 2.949999968210856,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 560,
				  faces: [
					{
					  x1: 514,
					  y1: 148,
					  x2: 1031,
					  y2: 665,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 561,
				  faces: [
					{
					  x1: 522,
					  y1: 148,
					  x2: 1038,
					  y2: 663,
					  speaking_score: 2.799999952316284,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 562,
				  faces: [
					{
					  x1: 536,
					  y1: 148,
					  x2: 1047,
					  y2: 660,
					  speaking_score: 2.766666611035665,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 563,
				  faces: [
					{
					  x1: 536,
					  y1: 146,
					  x2: 1052,
					  y2: 661,
					  speaking_score: 2.783333301544189,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 564,
				  faces: [
					{
					  x1: 535,
					  y1: 141,
					  x2: 1052,
					  y2: 658,
					  speaking_score: 2.899999976158142,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 565,
				  faces: [
					{
					  x1: 535,
					  y1: 136,
					  x2: 1052,
					  y2: 654,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 566,
				  faces: [
					{
					  x1: 535,
					  y1: 134,
					  x2: 1052,
					  y2: 651,
					  speaking_score: 2.850000023841858,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 567,
				  faces: [
					{
					  x1: 537,
					  y1: 135,
					  x2: 1050,
					  y2: 648,
					  speaking_score: 2.866666714350382,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 568,
				  faces: [
					{
					  x1: 538,
					  y1: 135,
					  x2: 1050,
					  y2: 646,
					  speaking_score: 2.866666714350382,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 569,
				  faces: [
					{
					  x1: 538,
					  y1: 134,
					  x2: 1049,
					  y2: 646,
					  speaking_score: 2.850000063578288,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 570,
				  faces: [
					{
					  x1: 538,
					  y1: 134,
					  x2: 1049,
					  y2: 646,
					  speaking_score: 2.866666754086812,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 571,
				  faces: [
					{
					  x1: 538,
					  y1: 134,
					  x2: 1049,
					  y2: 646,
					  speaking_score: 2.900000055631002,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 572,
				  faces: [
					{
					  x1: 538,
					  y1: 134,
					  x2: 1049,
					  y2: 646,
					  speaking_score: 2.916666706403097,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 573,
				  faces: [
					{
					  x1: 537,
					  y1: 134,
					  x2: 1050,
					  y2: 647,
					  speaking_score: 2.900000015894572,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 574,
				  faces: [
					{
					  x1: 537,
					  y1: 134,
					  x2: 1050,
					  y2: 647,
					  speaking_score: 2.900000015894572,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 575,
				  faces: [
					{
					  x1: 537,
					  y1: 134,
					  x2: 1049,
					  y2: 646,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 576,
				  faces: [
					{
					  x1: 542,
					  y1: 141,
					  x2: 1053,
					  y2: 652,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 577,
				  faces: [
					{
					  x1: 543,
					  y1: 142,
					  x2: 1052,
					  y2: 651,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 578,
				  faces: [
					{
					  x1: 545,
					  y1: 145,
					  x2: 1056,
					  y2: 656,
					  speaking_score: 2.716666698455811,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 579,
				  faces: [
					{
					  x1: 544,
					  y1: 146,
					  x2: 1056,
					  y2: 658,
					  speaking_score: 2.75000003973643,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 580,
				  faces: [
					{
					  x1: 544,
					  y1: 147,
					  x2: 1057,
					  y2: 660,
					  speaking_score: 2.783333381017049,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 581,
				  faces: [
					{
					  x1: 543,
					  y1: 148,
					  x2: 1058,
					  y2: 662,
					  speaking_score: 2.850000023841858,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 582,
				  faces: [
					{
					  x1: 543,
					  y1: 148,
					  x2: 1058,
					  y2: 663,
					  speaking_score: 2.833333333333333,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 583,
				  faces: [
					{
					  x1: 543,
					  y1: 148,
					  x2: 1058,
					  y2: 663,
					  speaking_score: 2.850000023841858,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 584,
				  faces: [
					{
					  x1: 544,
					  y1: 149,
					  x2: 1057,
					  y2: 662,
					  speaking_score: 2.833333333333333,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 585,
				  faces: [
					{
					  x1: 544,
					  y1: 149,
					  x2: 1056,
					  y2: 661,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 586,
				  faces: [
					{
					  x1: 541,
					  y1: 149,
					  x2: 1054,
					  y2: 661,
					  speaking_score: 2.833333333333333,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 587,
				  faces: [
					{
					  x1: 536,
					  y1: 149,
					  x2: 1049,
					  y2: 662,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 588,
				  faces: [
					{
					  x1: 528,
					  y1: 145,
					  x2: 1042,
					  y2: 658,
					  speaking_score: 2.99999996026357,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 589,
				  faces: [
					{
					  x1: 528,
					  y1: 141,
					  x2: 1041,
					  y2: 654,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 590,
				  faces: [
					{
					  x1: 527,
					  y1: 137,
					  x2: 1040,
					  y2: 650,
					  speaking_score: 3.116666634877523,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 591,
				  faces: [
					{
					  x1: 527,
					  y1: 137,
					  x2: 1039,
					  y2: 649,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 592,
				  faces: [
					{
					  x1: 527,
					  y1: 136,
					  x2: 1038,
					  y2: 647,
					  speaking_score: 2.983333309491476,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 593,
				  faces: [
					{
					  x1: 525,
					  y1: 135,
					  x2: 1036,
					  y2: 647,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 594,
				  faces: [
					{
					  x1: 525,
					  y1: 137,
					  x2: 1032,
					  y2: 644,
					  speaking_score: 2.799999992052714,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 595,
				  faces: [
					{
					  x1: 522,
					  y1: 136,
					  x2: 1028,
					  y2: 641,
					  speaking_score: 2.699999968210856,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 596,
				  faces: [
					{
					  x1: 523,
					  y1: 137,
					  x2: 1027,
					  y2: 640,
					  speaking_score: 2.583333293596903,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 597,
				  faces: [
					{
					  x1: 523,
					  y1: 137,
					  x2: 1026,
					  y2: 640,
					  speaking_score: 2.599999944368998,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 598,
				  faces: [
					{
					  x1: 523,
					  y1: 138,
					  x2: 1025,
					  y2: 639,
					  speaking_score: 2.683333277702332,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 599,
				  faces: [
					{
					  x1: 523,
					  y1: 138,
					  x2: 1025,
					  y2: 639,
					  speaking_score: 2.74999996026357,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 600,
				  faces: [
					{
					  x1: 523,
					  y1: 139,
					  x2: 1025,
					  y2: 640,
					  speaking_score: 2.799999992052714,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 601,
				  faces: [
					{
					  x1: 523,
					  y1: 139,
					  x2: 1025,
					  y2: 641,
					  speaking_score: 2.866666674613953,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 602,
				  faces: [
					{
					  x1: 521,
					  y1: 138,
					  x2: 1027,
					  y2: 644,
					  speaking_score: 2.950000007947286,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 603,
				  faces: [
					{
					  x1: 523,
					  y1: 141,
					  x2: 1026,
					  y2: 644,
					  speaking_score: 2.983333349227905,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 604,
				  faces: [
					{
					  x1: 524,
					  y1: 144,
					  x2: 1026,
					  y2: 645,
					  speaking_score: 2.933333357175191,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 605,
				  faces: [
					{
					  x1: 525,
					  y1: 144,
					  x2: 1027,
					  y2: 645,
					  speaking_score: 2.916666666666667,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 606,
				  faces: [
					{
					  x1: 531,
					  y1: 145,
					  x2: 1032,
					  y2: 647,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 607,
				  faces: [
					{
					  x1: 533,
					  y1: 146,
					  x2: 1034,
					  y2: 648,
					  speaking_score: 2.833333333333333,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 608,
				  faces: [
					{
					  x1: 533,
					  y1: 148,
					  x2: 1034,
					  y2: 650,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 609,
				  faces: [
					{
					  x1: 533,
					  y1: 149,
					  x2: 1034,
					  y2: 650,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 610,
				  faces: [
					{
					  x1: 532,
					  y1: 148,
					  x2: 1035,
					  y2: 652,
					  speaking_score: 2.75000003973643,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 611,
				  faces: [
					{
					  x1: 531,
					  y1: 148,
					  x2: 1036,
					  y2: 652,
					  speaking_score: 2.75000003973643,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 612,
				  faces: [
					{
					  x1: 531,
					  y1: 148,
					  x2: 1036,
					  y2: 652,
					  speaking_score: 2.766666690508524,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 613,
				  faces: [
					{
					  x1: 532,
					  y1: 148,
					  x2: 1035,
					  y2: 652,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 614,
				  faces: [
					{
					  x1: 527,
					  y1: 149,
					  x2: 1029,
					  y2: 651,
					  speaking_score: 2.666666666666667,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 615,
				  faces: [
					{
					  x1: 526,
					  y1: 148,
					  x2: 1029,
					  y2: 652,
					  speaking_score: 2.499999980131785,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 616,
				  faces: [
					{
					  x1: 523,
					  y1: 148,
					  x2: 1027,
					  y2: 652,
					  speaking_score: 2.349999984105428,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 617,
				  faces: [
					{
					  x1: 520,
					  y1: 148,
					  x2: 1025,
					  y2: 653,
					  speaking_score: 2.199999988079071,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 618,
				  faces: [
					{
					  x1: 517,
					  y1: 149,
					  x2: 1022,
					  y2: 654,
					  speaking_score: 2.133333305517832,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 619,
				  faces: [
					{
					  x1: 515,
					  y1: 148,
					  x2: 1021,
					  y2: 654,
					  speaking_score: 2.083333313465118,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 620,
				  faces: [
					{
					  x1: 515,
					  y1: 148,
					  x2: 1021,
					  y2: 655,
					  speaking_score: 2.066666662693024,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 621,
				  faces: [
					{
					  x1: 513,
					  y1: 148,
					  x2: 1020,
					  y2: 655,
					  speaking_score: 2.116666674613953,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 622,
				  faces: [
					{
					  x1: 512,
					  y1: 149,
					  x2: 1018,
					  y2: 654,
					  speaking_score: 2.183333337306976,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 623,
				  faces: [
					{
					  x1: 512,
					  y1: 149,
					  x2: 1018,
					  y2: 654,
					  speaking_score: 2.240000009536743,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 624,
				  faces: [
					{
					  x1: 513,
					  y1: 150,
					  x2: 1017,
					  y2: 654,
					  speaking_score: 2.225000023841858,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 625,
				  faces: [
					{
					  x1: 516,
					  y1: 151,
					  x2: 1014,
					  y2: 649,
					  speaking_score: 2.233333349227905,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 626,
				  faces: [
					{
					  x1: 516,
					  y1: 151,
					  x2: 1014,
					  y2: 649,
					  speaking_score: 2.25,
					  active: true,
					  track_id: 2,
					},
				  ],
				},
				{
				  frame_number: 627,
				  faces: [
				  ],
				},
				{
				  frame_number: 628,
				  faces: [
					{
					  x1: 595,
					  y1: 188,
					  x2: 851,
					  y2: 443,
					  speaking_score: 2.599999904632568,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 629,
				  faces: [
					{
					  x1: 595,
					  y1: 188,
					  x2: 851,
					  y2: 444,
					  speaking_score: 2.749999940395355,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 630,
				  faces: [
					{
					  x1: 595,
					  y1: 187,
					  x2: 852,
					  y2: 444,
					  speaking_score: 2.859999942779541,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 631,
				  faces: [
					{
					  x1: 595,
					  y1: 187,
					  x2: 852,
					  y2: 444,
					  speaking_score: 2.916666626930237,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 632,
				  faces: [
					{
					  x1: 594,
					  y1: 187,
					  x2: 852,
					  y2: 444,
					  speaking_score: 3.083333293596903,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 633,
				  faces: [
					{
					  x1: 594,
					  y1: 187,
					  x2: 852,
					  y2: 445,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 634,
				  faces: [
					{
					  x1: 594,
					  y1: 186,
					  x2: 853,
					  y2: 446,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 635,
				  faces: [
					{
					  x1: 593,
					  y1: 186,
					  x2: 854,
					  y2: 446,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 636,
				  faces: [
					{
					  x1: 593,
					  y1: 186,
					  x2: 854,
					  y2: 446,
					  speaking_score: 3.433333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 637,
				  faces: [
					{
					  x1: 593,
					  y1: 185,
					  x2: 854,
					  y2: 447,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 638,
				  faces: [
					{
					  x1: 592,
					  y1: 185,
					  x2: 854,
					  y2: 447,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 639,
				  faces: [
					{
					  x1: 593,
					  y1: 185,
					  x2: 854,
					  y2: 447,
					  speaking_score: 3.483333309491476,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 640,
				  faces: [
					{
					  x1: 595,
					  y1: 185,
					  x2: 857,
					  y2: 447,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 641,
				  faces: [
					{
					  x1: 597,
					  y1: 185,
					  x2: 859,
					  y2: 447,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 642,
				  faces: [
					{
					  x1: 601,
					  y1: 187,
					  x2: 861,
					  y2: 447,
					  speaking_score: 3.366666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 643,
				  faces: [
					{
					  x1: 603,
					  y1: 187,
					  x2: 863,
					  y2: 447,
					  speaking_score: 3.349999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 644,
				  faces: [
					{
					  x1: 605,
					  y1: 187,
					  x2: 865,
					  y2: 447,
					  speaking_score: 3.349999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 645,
				  faces: [
					{
					  x1: 606,
					  y1: 188,
					  x2: 867,
					  y2: 448,
					  speaking_score: 3.383333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 646,
				  faces: [
					{
					  x1: 606,
					  y1: 188,
					  x2: 867,
					  y2: 448,
					  speaking_score: 3.399999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 647,
				  faces: [
					{
					  x1: 606,
					  y1: 188,
					  x2: 867,
					  y2: 449,
					  speaking_score: 3.433333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 648,
				  faces: [
					{
					  x1: 606,
					  y1: 191,
					  x2: 867,
					  y2: 452,
					  speaking_score: 3.450000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 649,
				  faces: [
					{
					  x1: 606,
					  y1: 191,
					  x2: 867,
					  y2: 452,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 650,
				  faces: [
					{
					  x1: 607,
					  y1: 192,
					  x2: 866,
					  y2: 451,
					  speaking_score: 3.383333365122477,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 651,
				  faces: [
					{
					  x1: 607,
					  y1: 192,
					  x2: 866,
					  y2: 451,
					  speaking_score: 3.333333373069763,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 652,
				  faces: [
					{
					  x1: 607,
					  y1: 192,
					  x2: 865,
					  y2: 450,
					  speaking_score: 3.283333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 653,
				  faces: [
					{
					  x1: 605,
					  y1: 192,
					  x2: 864,
					  y2: 451,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 654,
				  faces: [
					{
					  x1: 602,
					  y1: 192,
					  x2: 861,
					  y2: 451,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 655,
				  faces: [
					{
					  x1: 599,
					  y1: 189,
					  x2: 859,
					  y2: 448,
					  speaking_score: 3.416666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 656,
				  faces: [
					{
					  x1: 596,
					  y1: 185,
					  x2: 856,
					  y2: 445,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 657,
				  faces: [
					{
					  x1: 592,
					  y1: 184,
					  x2: 853,
					  y2: 445,
					  speaking_score: 3.483333309491476,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 658,
				  faces: [
					{
					  x1: 589,
					  y1: 183,
					  x2: 850,
					  y2: 444,
					  speaking_score: 3.516666650772095,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 659,
				  faces: [
					{
					  x1: 585,
					  y1: 183,
					  x2: 846,
					  y2: 444,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 660,
				  faces: [
					{
					  x1: 581,
					  y1: 183,
					  x2: 841,
					  y2: 442,
					  speaking_score: 3.450000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 661,
				  faces: [
					{
					  x1: 580,
					  y1: 183,
					  x2: 840,
					  y2: 442,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 662,
				  faces: [
					{
					  x1: 580,
					  y1: 183,
					  x2: 840,
					  y2: 442,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 663,
				  faces: [
					{
					  x1: 580,
					  y1: 183,
					  x2: 840,
					  y2: 442,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 664,
				  faces: [
					{
					  x1: 580,
					  y1: 182,
					  x2: 841,
					  y2: 443,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 665,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 841,
					  y2: 443,
					  speaking_score: 3.433333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 666,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 841,
					  y2: 445,
					  speaking_score: 3.349999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 667,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 841,
					  y2: 445,
					  speaking_score: 3.199999968210856,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 668,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 842,
					  y2: 445,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 669,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 842,
					  y2: 445,
					  speaking_score: 2.949999968210856,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 670,
				  faces: [
					{
					  x1: 579,
					  y1: 182,
					  x2: 842,
					  y2: 445,
					  speaking_score: 2.883333285649618,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 671,
				  faces: [
					{
					  x1: 578,
					  y1: 182,
					  x2: 843,
					  y2: 447,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 672,
				  faces: [
					{
					  x1: 578,
					  y1: 182,
					  x2: 843,
					  y2: 447,
					  speaking_score: 2.849999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 673,
				  faces: [
					{
					  x1: 578,
					  y1: 182,
					  x2: 843,
					  y2: 447,
					  speaking_score: 2.883333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 674,
				  faces: [
					{
					  x1: 578,
					  y1: 181,
					  x2: 844,
					  y2: 447,
					  speaking_score: 2.933333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 675,
				  faces: [
					{
					  x1: 578,
					  y1: 181,
					  x2: 844,
					  y2: 447,
					  speaking_score: 3,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 676,
				  faces: [
					{
					  x1: 578,
					  y1: 181,
					  x2: 844,
					  y2: 447,
					  speaking_score: 3.100000023841858,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 677,
				  faces: [
					{
					  x1: 578,
					  y1: 181,
					  x2: 844,
					  y2: 447,
					  speaking_score: 3.200000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 678,
				  faces: [
					{
					  x1: 578,
					  y1: 180,
					  x2: 844,
					  y2: 446,
					  speaking_score: 3.283333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 679,
				  faces: [
					{
					  x1: 578,
					  y1: 180,
					  x2: 843,
					  y2: 446,
					  speaking_score: 3.416666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 680,
				  faces: [
					{
					  x1: 577,
					  y1: 180,
					  x2: 842,
					  y2: 445,
					  speaking_score: 3.516666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 681,
				  faces: [
					{
					  x1: 577,
					  y1: 179,
					  x2: 841,
					  y2: 444,
					  speaking_score: 3.550000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 682,
				  faces: [
					{
					  x1: 579,
					  y1: 179,
					  x2: 840,
					  y2: 440,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 683,
				  faces: [
					{
					  x1: 580,
					  y1: 179,
					  x2: 838,
					  y2: 438,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 684,
				  faces: [
					{
					  x1: 581,
					  y1: 179,
					  x2: 837,
					  y2: 434,
					  speaking_score: 2.916666706403097,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 685,
				  faces: [
					{
					  x1: 582,
					  y1: 179,
					  x2: 836,
					  y2: 433,
					  speaking_score: 2.766666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 686,
				  faces: [
					{
					  x1: 585,
					  y1: 179,
					  x2: 838,
					  y2: 431,
					  speaking_score: 2.633333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 687,
				  faces: [
					{
					  x1: 587,
					  y1: 179,
					  x2: 839,
					  y2: 431,
					  speaking_score: 2.599999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 688,
				  faces: [
					{
					  x1: 590,
					  y1: 179,
					  x2: 837,
					  y2: 425,
					  speaking_score: 2.683333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 689,
				  faces: [
					{
					  x1: 591,
					  y1: 178,
					  x2: 836,
					  y2: 423,
					  speaking_score: 2.75,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 690,
				  faces: [
					{
					  x1: 592,
					  y1: 177,
					  x2: 836,
					  y2: 421,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 691,
				  faces: [
					{
					  x1: 592,
					  y1: 177,
					  x2: 836,
					  y2: 420,
					  speaking_score: 2.800000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 692,
				  faces: [
					{
					  x1: 594,
					  y1: 177,
					  x2: 838,
					  y2: 420,
					  speaking_score: 2.850000063578288,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 693,
				  faces: [
					{
					  x1: 595,
					  y1: 177,
					  x2: 839,
					  y2: 420,
					  speaking_score: 2.866666754086812,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 694,
				  faces: [
					{
					  x1: 597,
					  y1: 177,
					  x2: 840,
					  y2: 420,
					  speaking_score: 2.883333404858907,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 695,
				  faces: [
					{
					  x1: 599,
					  y1: 177,
					  x2: 843,
					  y2: 420,
					  speaking_score: 2.96666673819224,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 696,
				  faces: [
					{
					  x1: 600,
					  y1: 177,
					  x2: 843,
					  y2: 420,
					  speaking_score: 3.016666730244955,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 697,
				  faces: [
					{
					  x1: 600,
					  y1: 177,
					  x2: 843,
					  y2: 420,
					  speaking_score: 3.050000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 698,
				  faces: [
					{
					  x1: 601,
					  y1: 177,
					  x2: 845,
					  y2: 421,
					  speaking_score: 2.900000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 699,
				  faces: [
					{
					  x1: 603,
					  y1: 179,
					  x2: 847,
					  y2: 423,
					  speaking_score: 2.73333332935969,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 700,
				  faces: [
					{
					  x1: 604,
					  y1: 180,
					  x2: 850,
					  y2: 426,
					  speaking_score: 2.533333321412405,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 701,
				  faces: [
					{
					  x1: 603,
					  y1: 181,
					  x2: 851,
					  y2: 429,
					  speaking_score: 2.316666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 702,
				  faces: [
					{
					  x1: 603,
					  y1: 182,
					  x2: 852,
					  y2: 431,
					  speaking_score: 2.083333293596903,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 703,
				  faces: [
					{
					  x1: 601,
					  y1: 182,
					  x2: 853,
					  y2: 434,
					  speaking_score: 1.949999968210856,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 704,
				  faces: [
					{
					  x1: 601,
					  y1: 183,
					  x2: 854,
					  y2: 436,
					  speaking_score: 2.166666626930237,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 705,
				  faces: [
					{
					  x1: 601,
					  y1: 183,
					  x2: 854,
					  y2: 436,
					  speaking_score: 2.416666646798452,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 706,
				  faces: [
					{
					  x1: 600,
					  y1: 183,
					  x2: 854,
					  y2: 437,
					  speaking_score: 2.666666646798452,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 707,
				  faces: [
					{
					  x1: 599,
					  y1: 183,
					  x2: 854,
					  y2: 438,
					  speaking_score: 2.916666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 708,
				  faces: [
					{
					  x1: 595,
					  y1: 184,
					  x2: 851,
					  y2: 440,
					  speaking_score: 3.416666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 709,
				  faces: [
					{
					  x1: 593,
					  y1: 184,
					  x2: 849,
					  y2: 440,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 710,
				  faces: [
					{
					  x1: 592,
					  y1: 187,
					  x2: 849,
					  y2: 443,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 711,
				  faces: [
					{
					  x1: 590,
					  y1: 187,
					  x2: 848,
					  y2: 445,
					  speaking_score: 3.516666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 712,
				  faces: [
					{
					  x1: 589,
					  y1: 187,
					  x2: 847,
					  y2: 445,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 713,
				  faces: [
					{
					  x1: 588,
					  y1: 187,
					  x2: 847,
					  y2: 445,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 714,
				  faces: [
					{
					  x1: 588,
					  y1: 187,
					  x2: 847,
					  y2: 445,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 715,
				  faces: [
					{
					  x1: 588,
					  y1: 187,
					  x2: 847,
					  y2: 445,
					  speaking_score: 3.299999992052714,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 716,
				  faces: [
					{
					  x1: 588,
					  y1: 186,
					  x2: 848,
					  y2: 447,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 717,
				  faces: [
					{
					  x1: 588,
					  y1: 187,
					  x2: 848,
					  y2: 447,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 718,
				  faces: [
					{
					  x1: 588,
					  y1: 188,
					  x2: 848,
					  y2: 448,
					  speaking_score: 3.149999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 719,
				  faces: [
					{
					  x1: 589,
					  y1: 188,
					  x2: 849,
					  y2: 448,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 720,
				  faces: [
					{
					  x1: 591,
					  y1: 188,
					  x2: 851,
					  y2: 449,
					  speaking_score: 3.149999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 721,
				  faces: [
					{
					  x1: 591,
					  y1: 188,
					  x2: 851,
					  y2: 449,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 722,
				  faces: [
					{
					  x1: 593,
					  y1: 188,
					  x2: 853,
					  y2: 449,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 723,
				  faces: [
					{
					  x1: 595,
					  y1: 191,
					  x2: 855,
					  y2: 451,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 724,
				  faces: [
					{
					  x1: 597,
					  y1: 194,
					  x2: 857,
					  y2: 454,
					  speaking_score: 3.200000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 725,
				  faces: [
					{
					  x1: 598,
					  y1: 197,
					  x2: 859,
					  y2: 457,
					  speaking_score: 3.233333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 726,
				  faces: [
					{
					  x1: 600,
					  y1: 199,
					  x2: 861,
					  y2: 460,
					  speaking_score: 3.25000003973643,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 727,
				  faces: [
					{
					  x1: 602,
					  y1: 202,
					  x2: 863,
					  y2: 463,
					  speaking_score: 3.266666730244955,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 728,
				  faces: [
					{
					  x1: 603,
					  y1: 208,
					  x2: 865,
					  y2: 470,
					  speaking_score: 3.333333412806193,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 729,
				  faces: [
					{
					  x1: 601,
					  y1: 211,
					  x2: 866,
					  y2: 476,
					  speaking_score: 3.333333412806193,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 730,
				  faces: [
					{
					  x1: 601,
					  y1: 212,
					  x2: 866,
					  y2: 477,
					  speaking_score: 3.350000063578288,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 731,
				  faces: [
					{
					  x1: 601,
					  y1: 212,
					  x2: 866,
					  y2: 477,
					  speaking_score: 3.366666714350382,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 732,
				  faces: [
					{
					  x1: 601,
					  y1: 211,
					  x2: 867,
					  y2: 477,
					  speaking_score: 3.466666698455811,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 733,
				  faces: [
					{
					  x1: 600,
					  y1: 210,
					  x2: 868,
					  y2: 478,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 734,
				  faces: [
					{
					  x1: 598,
					  y1: 210,
					  x2: 865,
					  y2: 478,
					  speaking_score: 3.650000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 735,
				  faces: [
					{
					  x1: 594,
					  y1: 210,
					  x2: 862,
					  y2: 478,
					  speaking_score: 3.75000003973643,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 736,
				  faces: [
					{
					  x1: 592,
					  y1: 208,
					  x2: 858,
					  y2: 475,
					  speaking_score: 3.783333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 737,
				  faces: [
					{
					  x1: 589,
					  y1: 206,
					  x2: 856,
					  y2: 472,
					  speaking_score: 3.766666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 738,
				  faces: [
					{
					  x1: 588,
					  y1: 204,
					  x2: 854,
					  y2: 470,
					  speaking_score: 3.733333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 739,
				  faces: [
					{
					  x1: 587,
					  y1: 201,
					  x2: 853,
					  y2: 467,
					  speaking_score: 3.666666706403097,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 740,
				  faces: [
					{
					  x1: 587,
					  y1: 199,
					  x2: 852,
					  y2: 464,
					  speaking_score: 3.616666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 741,
				  faces: [
					{
					  x1: 585,
					  y1: 197,
					  x2: 851,
					  y2: 463,
					  speaking_score: 3.549999992052714,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 742,
				  faces: [
					{
					  x1: 585,
					  y1: 197,
					  x2: 850,
					  y2: 463,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 743,
				  faces: [
					{
					  x1: 585,
					  y1: 197,
					  x2: 850,
					  y2: 463,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 744,
				  faces: [
					{
					  x1: 586,
					  y1: 199,
					  x2: 848,
					  y2: 461,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 745,
				  faces: [
					{
					  x1: 586,
					  y1: 199,
					  x2: 848,
					  y2: 461,
					  speaking_score: 3.516666650772095,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 746,
				  faces: [
					{
					  x1: 587,
					  y1: 200,
					  x2: 847,
					  y2: 460,
					  speaking_score: 3.333333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 747,
				  faces: [
					{
					  x1: 586,
					  y1: 200,
					  x2: 846,
					  y2: 460,
					  speaking_score: 3.150000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 748,
				  faces: [
					{
					  x1: 585,
					  y1: 199,
					  x2: 847,
					  y2: 461,
					  speaking_score: 3.033333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 749,
				  faces: [
					{
					  x1: 584,
					  y1: 200,
					  x2: 846,
					  y2: 462,
					  speaking_score: 2.916666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 750,
				  faces: [
					{
					  x1: 584,
					  y1: 206,
					  x2: 846,
					  y2: 468,
					  speaking_score: 2.733333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 751,
				  faces: [
					{
					  x1: 583,
					  y1: 208,
					  x2: 845,
					  y2: 469,
					  speaking_score: 2.616666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 752,
				  faces: [
					{
					  x1: 584,
					  y1: 209,
					  x2: 844,
					  y2: 468,
					  speaking_score: 2.600000023841858,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 753,
				  faces: [
					{
					  x1: 584,
					  y1: 209,
					  x2: 844,
					  y2: 468,
					  speaking_score: 2.700000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 754,
				  faces: [
					{
					  x1: 584,
					  y1: 209,
					  x2: 843,
					  y2: 468,
					  speaking_score: 2.75,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 755,
				  faces: [
					{
					  x1: 583,
					  y1: 209,
					  x2: 843,
					  y2: 468,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 756,
				  faces: [
					{
					  x1: 580,
					  y1: 209,
					  x2: 840,
					  y2: 468,
					  speaking_score: 2.966666698455811,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 757,
				  faces: [
					{
					  x1: 577,
					  y1: 205,
					  x2: 837,
					  y2: 465,
					  speaking_score: 3.083333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 758,
				  faces: [
					{
					  x1: 575,
					  y1: 202,
					  x2: 834,
					  y2: 462,
					  speaking_score: 3.083333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 759,
				  faces: [
					{
					  x1: 574,
					  y1: 202,
					  x2: 833,
					  y2: 461,
					  speaking_score: 3.033333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 760,
				  faces: [
					{
					  x1: 574,
					  y1: 201,
					  x2: 833,
					  y2: 459,
					  speaking_score: 2.916666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 761,
				  faces: [
					{
					  x1: 574,
					  y1: 196,
					  x2: 833,
					  y2: 455,
					  speaking_score: 2.766666650772095,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 762,
				  faces: [
					{
					  x1: 575,
					  y1: 194,
					  x2: 832,
					  y2: 452,
					  speaking_score: 2.649999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 763,
				  faces: [
					{
					  x1: 575,
					  y1: 194,
					  x2: 832,
					  y2: 451,
					  speaking_score: 2.466666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 764,
				  faces: [
					{
					  x1: 576,
					  y1: 194,
					  x2: 831,
					  y2: 449,
					  speaking_score: 2.25,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 765,
				  faces: [
					{
					  x1: 576,
					  y1: 192,
					  x2: 830,
					  y2: 446,
					  speaking_score: 2.099999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 766,
				  faces: [
					{
					  x1: 577,
					  y1: 189,
					  x2: 830,
					  y2: 441,
					  speaking_score: 1.949999988079071,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 767,
				  faces: [
					{
					  x1: 579,
					  y1: 185,
					  x2: 831,
					  y2: 436,
					  speaking_score: 1.833333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 768,
				  faces: [
					{
					  x1: 580,
					  y1: 183,
					  x2: 832,
					  y2: 435,
					  speaking_score: 1.816666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 769,
				  faces: [
					{
					  x1: 581,
					  y1: 184,
					  x2: 831,
					  y2: 435,
					  speaking_score: 1.866666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 770,
				  faces: [
					{
					  x1: 581,
					  y1: 183,
					  x2: 832,
					  y2: 433,
					  speaking_score: 2.066666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 771,
				  faces: [
					{
					  x1: 581,
					  y1: 182,
					  x2: 832,
					  y2: 433,
					  speaking_score: 2.25000003973643,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 772,
				  faces: [
					{
					  x1: 581,
					  y1: 181,
					  x2: 832,
					  y2: 432,
					  speaking_score: 2.48333336909612,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 773,
				  faces: [
					{
					  x1: 582,
					  y1: 182,
					  x2: 832,
					  y2: 432,
					  speaking_score: 2.700000047683716,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 774,
				  faces: [
					{
					  x1: 582,
					  y1: 182,
					  x2: 832,
					  y2: 431,
					  speaking_score: 2.850000023841858,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 775,
				  faces: [
					{
					  x1: 584,
					  y1: 182,
					  x2: 832,
					  y2: 430,
					  speaking_score: 3.033333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 776,
				  faces: [
					{
					  x1: 585,
					  y1: 182,
					  x2: 833,
					  y2: 430,
					  speaking_score: 3.116666714350382,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 777,
				  faces: [
					{
					  x1: 588,
					  y1: 182,
					  x2: 836,
					  y2: 430,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 778,
				  faces: [
					{
					  x1: 590,
					  y1: 182,
					  x2: 837,
					  y2: 430,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 779,
				  faces: [
					{
					  x1: 592,
					  y1: 183,
					  x2: 840,
					  y2: 431,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 780,
				  faces: [
					{
					  x1: 596,
					  y1: 183,
					  x2: 844,
					  y2: 431,
					  speaking_score: 3.649999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 781,
				  faces: [
					{
					  x1: 599,
					  y1: 184,
					  x2: 845,
					  y2: 430,
					  speaking_score: 3.683333277702332,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 782,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 847,
					  y2: 430,
					  speaking_score: 3.616666634877523,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 783,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 846,
					  y2: 429,
					  speaking_score: 3.566666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 784,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 846,
					  y2: 430,
					  speaking_score: 3.533333301544189,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 785,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 846,
					  y2: 430,
					  speaking_score: 3.5,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 786,
				  faces: [
					{
					  x1: 602,
					  y1: 184,
					  x2: 847,
					  y2: 430,
					  speaking_score: 3.450000007947286,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 787,
				  faces: [
					{
					  x1: 602,
					  y1: 184,
					  x2: 847,
					  y2: 429,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 788,
				  faces: [
					{
					  x1: 602,
					  y1: 185,
					  x2: 846,
					  y2: 429,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 789,
				  faces: [
					{
					  x1: 603,
					  y1: 185,
					  x2: 846,
					  y2: 429,
					  speaking_score: 3.383333365122477,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 790,
				  faces: [
					{
					  x1: 603,
					  y1: 185,
					  x2: 846,
					  y2: 429,
					  speaking_score: 3.333333373069763,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 791,
				  faces: [
					{
					  x1: 603,
					  y1: 185,
					  x2: 846,
					  y2: 429,
					  speaking_score: 3.233333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 792,
				  faces: [
					{
					  x1: 602,
					  y1: 185,
					  x2: 847,
					  y2: 429,
					  speaking_score: 3.150000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 793,
				  faces: [
					{
					  x1: 602,
					  y1: 184,
					  x2: 847,
					  y2: 430,
					  speaking_score: 3.100000023841858,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 794,
				  faces: [
					{
					  x1: 603,
					  y1: 184,
					  x2: 851,
					  y2: 432,
					  speaking_score: 3.066666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 795,
				  faces: [
					{
					  x1: 605,
					  y1: 183,
					  x2: 854,
					  y2: 432,
					  speaking_score: 3.049999992052714,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 796,
				  faces: [
					{
					  x1: 602,
					  y1: 183,
					  x2: 858,
					  y2: 439,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 797,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.149999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 798,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 799,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 800,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.233333309491476,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 801,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 802,
				  faces: [
					{
					  x1: 601,
					  y1: 184,
					  x2: 859,
					  y2: 442,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 803,
				  faces: [
					{
					  x1: 598,
					  y1: 184,
					  x2: 857,
					  y2: 442,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 804,
				  faces: [
					{
					  x1: 593,
					  y1: 177,
					  x2: 841,
					  y2: 424,
					  speaking_score: 3.216666618982951,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 805,
				  faces: [
					{
					  x1: 586,
					  y1: 177,
					  x2: 834,
					  y2: 424,
					  speaking_score: 3.216666618982951,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 806,
				  faces: [
					{
					  x1: 582,
					  y1: 177,
					  x2: 827,
					  y2: 422,
					  speaking_score: 3.233333269755045,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 807,
				  faces: [
					{
					  x1: 576,
					  y1: 177,
					  x2: 820,
					  y2: 420,
					  speaking_score: 3.216666618982951,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 808,
				  faces: [
					{
					  x1: 571,
					  y1: 177,
					  x2: 813,
					  y2: 419,
					  speaking_score: 3.266666611035665,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 809,
				  faces: [
					{
					  x1: 566,
					  y1: 177,
					  x2: 808,
					  y2: 419,
					  speaking_score: 3.366666634877523,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 810,
				  faces: [
					{
					  x1: 564,
					  y1: 177,
					  x2: 806,
					  y2: 419,
					  speaking_score: 3.416666626930237,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 811,
				  faces: [
					{
					  x1: 561,
					  y1: 176,
					  x2: 805,
					  y2: 420,
					  speaking_score: 3.483333309491476,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 812,
				  faces: [
					{
					  x1: 559,
					  y1: 176,
					  x2: 804,
					  y2: 421,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 813,
				  faces: [
					{
					  x1: 558,
					  y1: 176,
					  x2: 805,
					  y2: 423,
					  speaking_score: 3.566666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 814,
				  faces: [
					{
					  x1: 558,
					  y1: 177,
					  x2: 805,
					  y2: 424,
					  speaking_score: 3.533333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 815,
				  faces: [
					{
					  x1: 558,
					  y1: 177,
					  x2: 805,
					  y2: 424,
					  speaking_score: 3.50000003973643,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 816,
				  faces: [
					{
					  x1: 555,
					  y1: 175,
					  x2: 807,
					  y2: 427,
					  speaking_score: 3.516666730244955,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 817,
				  faces: [
					{
					  x1: 555,
					  y1: 176,
					  x2: 807,
					  y2: 428,
					  speaking_score: 3.533333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 818,
				  faces: [
					{
					  x1: 554,
					  y1: 176,
					  x2: 808,
					  y2: 430,
					  speaking_score: 3.483333349227905,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 819,
				  faces: [
					{
					  x1: 554,
					  y1: 176,
					  x2: 808,
					  y2: 430,
					  speaking_score: 3.466666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 820,
				  faces: [
					{
					  x1: 554,
					  y1: 176,
					  x2: 808,
					  y2: 430,
					  speaking_score: 3.399999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 821,
				  faces: [
					{
					  x1: 555,
					  y1: 176,
					  x2: 809,
					  y2: 431,
					  speaking_score: 3.316666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 822,
				  faces: [
					{
					  x1: 555,
					  y1: 177,
					  x2: 809,
					  y2: 431,
					  speaking_score: 3.216666618982951,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 823,
				  faces: [
					{
					  x1: 555,
					  y1: 177,
					  x2: 810,
					  y2: 433,
					  speaking_score: 3.099999944368998,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 824,
				  faces: [
					{
					  x1: 555,
					  y1: 179,
					  x2: 810,
					  y2: 435,
					  speaking_score: 3.066666642824809,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 825,
				  faces: [
					{
					  x1: 555,
					  y1: 180,
					  x2: 810,
					  y2: 436,
					  speaking_score: 2.916666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 826,
				  faces: [
					{
					  x1: 555,
					  y1: 181,
					  x2: 810,
					  y2: 436,
					  speaking_score: 2.816666682561239,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 827,
				  faces: [
					{
					  x1: 555,
					  y1: 186,
					  x2: 811,
					  y2: 442,
					  speaking_score: 2.783333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 828,
				  faces: [
					{
					  x1: 568,
					  y1: 214,
					  x2: 821,
					  y2: 467,
					  speaking_score: 2.800000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 829,
				  faces: [
					{
					  x1: 576,
					  y1: 227,
					  x2: 828,
					  y2: 479,
					  speaking_score: 2.866666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 830,
				  faces: [
					{
					  x1: 576,
					  y1: 238,
					  x2: 828,
					  y2: 490,
					  speaking_score: 3,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 831,
				  faces: [
					{
					  x1: 578,
					  y1: 241,
					  x2: 827,
					  y2: 490,
					  speaking_score: 3.133333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 832,
				  faces: [
					{
					  x1: 579,
					  y1: 242,
					  x2: 827,
					  y2: 490,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 833,
				  faces: [
					{
					  x1: 580,
					  y1: 245,
					  x2: 828,
					  y2: 493,
					  speaking_score: 3.183333317438761,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 834,
				  faces: [
					{
					  x1: 588,
					  y1: 248,
					  x2: 831,
					  y2: 491,
					  speaking_score: 3.149999976158142,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 835,
				  faces: [
					{
					  x1: 588,
					  y1: 252,
					  x2: 831,
					  y2: 495,
					  speaking_score: 3.099999984105428,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 836,
				  faces: [
					{
					  x1: 589,
					  y1: 253,
					  x2: 830,
					  y2: 495,
					  speaking_score: 3.083333293596903,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 837,
				  faces: [
					{
					  x1: 593,
					  y1: 257,
					  x2: 834,
					  y2: 498,
					  speaking_score: 3.083333293596903,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 838,
				  faces: [
					{
					  x1: 593,
					  y1: 257,
					  x2: 834,
					  y2: 498,
					  speaking_score: 3.116666634877523,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 839,
				  faces: [
					{
					  x1: 592,
					  y1: 259,
					  x2: 835,
					  y2: 502,
					  speaking_score: 3.166666666666667,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 840,
				  faces: [
					{
					  x1: 591,
					  y1: 261,
					  x2: 835,
					  y2: 505,
					  speaking_score: 3.25,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 841,
				  faces: [
					{
					  x1: 591,
					  y1: 261,
					  x2: 835,
					  y2: 505,
					  speaking_score: 3.299999992052714,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 842,
				  faces: [
					{
					  x1: 591,
					  y1: 261,
					  x2: 835,
					  y2: 505,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 843,
				  faces: [
					{
					  x1: 591,
					  y1: 261,
					  x2: 835,
					  y2: 505,
					  speaking_score: 3.216666698455811,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 844,
				  faces: [
					{
					  x1: 591,
					  y1: 261,
					  x2: 835,
					  y2: 505,
					  speaking_score: 3.166666706403097,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 845,
				  faces: [
					{
					  x1: 587,
					  y1: 257,
					  x2: 840,
					  y2: 510,
					  speaking_score: 3.133333365122477,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 846,
				  faces: [
					{
					  x1: 586,
					  y1: 255,
					  x2: 841,
					  y2: 511,
					  speaking_score: 3.133333365122477,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 847,
				  faces: [
					{
					  x1: 584,
					  y1: 242,
					  x2: 841,
					  y2: 499,
					  speaking_score: 3.166666706403097,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 848,
				  faces: [
					{
					  x1: 576,
					  y1: 229,
					  x2: 834,
					  y2: 486,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 849,
				  faces: [
					{
					  x1: 572,
					  y1: 215,
					  x2: 832,
					  y2: 475,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 850,
				  faces: [
					{
					  x1: 569,
					  y1: 207,
					  x2: 828,
					  y2: 467,
					  speaking_score: 3.533333341280619,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 851,
				  faces: [
					{
					  x1: 568,
					  y1: 199,
					  x2: 828,
					  y2: 458,
					  speaking_score: 3.616666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 852,
				  faces: [
					{
					  x1: 567,
					  y1: 191,
					  x2: 827,
					  y2: 451,
					  speaking_score: 3.633333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 853,
				  faces: [
					{
					  x1: 564,
					  y1: 192,
					  x2: 822,
					  y2: 450,
					  speaking_score: 3.583333333333333,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 854,
				  faces: [
					{
					  x1: 563,
					  y1: 189,
					  x2: 824,
					  y2: 450,
					  speaking_score: 3.549999992052714,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 855,
				  faces: [
					{
					  x1: 562,
					  y1: 185,
					  x2: 825,
					  y2: 447,
					  speaking_score: 3.516666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 856,
				  faces: [
					{
					  x1: 562,
					  y1: 184,
					  x2: 825,
					  y2: 446,
					  speaking_score: 3.433333357175191,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 857,
				  faces: [
					{
					  x1: 562,
					  y1: 182,
					  x2: 825,
					  y2: 445,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 858,
				  faces: [
					{
					  x1: 562,
					  y1: 182,
					  x2: 824,
					  y2: 444,
					  speaking_score: 3.366666714350382,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 859,
				  faces: [
					{
					  x1: 562,
					  y1: 182,
					  x2: 824,
					  y2: 444,
					  speaking_score: 3.333333373069763,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 860,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 3.316666722297668,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 861,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 3.25000003973643,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 862,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 3.183333357175191,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 863,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 3.033333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 864,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 823,
					  y2: 444,
					  speaking_score: 2.833333373069763,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 865,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 823,
					  y2: 444,
					  speaking_score: 2.583333373069763,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 866,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 823,
					  y2: 444,
					  speaking_score: 1.983333356678486,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 867,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 1.483333356678486,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 868,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 1.050000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 869,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 0.7000000178813934,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 870,
				  faces: [
					{
					  x1: 560,
					  y1: 182,
					  x2: 822,
					  y2: 444,
					  speaking_score: 0.4166666766007741,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 871,
				  faces: [
					{
					  x1: 560,
					  y1: 183,
					  x2: 822,
					  y2: 445,
					  speaking_score: 0.2000000029802322,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 872,
				  faces: [
					{
					  x1: 560,
					  y1: 183,
					  x2: 822,
					  y2: 445,
					  speaking_score: 0.3500000014901161,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 873,
				  faces: [
					{
					  x1: 560,
					  y1: 183,
					  x2: 822,
					  y2: 445,
					  speaking_score: 0.750000017384688,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 874,
				  faces: [
					{
					  x1: 562,
					  y1: 184,
					  x2: 824,
					  y2: 445,
					  speaking_score: 1.266666675607363,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 875,
				  faces: [
					{
					  x1: 563,
					  y1: 184,
					  x2: 823,
					  y2: 444,
					  speaking_score: 1.800000006953875,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 876,
				  faces: [
					{
					  x1: 563,
					  y1: 185,
					  x2: 823,
					  y2: 445,
					  speaking_score: 2.733333339293798,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 877,
				  faces: [
					{
					  x1: 565,
					  y1: 187,
					  x2: 823,
					  y2: 445,
					  speaking_score: 3.216666658719381,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 878,
				  faces: [
					{
					  x1: 566,
					  y1: 187,
					  x2: 824,
					  y2: 445,
					  speaking_score: 3.383333325386047,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 879,
				  faces: [
					{
					  x1: 567,
					  y1: 188,
					  x2: 824,
					  y2: 446,
					  speaking_score: 3.400000015894572,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 880,
				  faces: [
					{
					  x1: 567,
					  y1: 188,
					  x2: 825,
					  y2: 446,
					  speaking_score: 3.366666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 881,
				  faces: [
					{
					  x1: 566,
					  y1: 189,
					  x2: 826,
					  y2: 449,
					  speaking_score: 3.366666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 882,
				  faces: [
					{
					  x1: 566,
					  y1: 189,
					  x2: 826,
					  y2: 449,
					  speaking_score: 3.366666674613953,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 883,
				  faces: [
					{
					  x1: 567,
					  y1: 189,
					  x2: 827,
					  y2: 449,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 884,
				  faces: [
					{
					  x1: 567,
					  y1: 188,
					  x2: 827,
					  y2: 448,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 885,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 447,
					  speaking_score: 3.25,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 886,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 447,
					  speaking_score: 3.266666690508524,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 887,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 447,
					  speaking_score: 3.300000031789144,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 888,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 447,
					  speaking_score: 3.283333381017049,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 889,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 446,
					  speaking_score: 3.300000047683716,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 890,
				  faces: [
					{
					  x1: 569,
					  y1: 188,
					  x2: 828,
					  y2: 446,
					  speaking_score: 3.325000047683716,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 891,
				  faces: [
					{
					  x1: 569,
					  y1: 187,
					  x2: 828,
					  y2: 446,
					  speaking_score: 3.333333412806193,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 892,
				  faces: [
					{
					  x1: 570,
					  y1: 187,
					  x2: 827,
					  y2: 444,
					  speaking_score: 3.300000071525574,
					  active: true,
					  track_id: 3,
					},
				  ],
				},
				{
				  frame_number: 893,
				  faces: [
				  ],
				},
			  ],
			  video_info: {
				fps: 24,
				processing_fps: 25,
				total_frames: 894,
				duration: 37.291,
				start_time: 0,
				end_time: 37.291,
				frame_numbers_start_from: 0,
				resolution: {
				  width: 1920,
				  height: 960,
				},
			  },
			  scenes: [
				{
				  scene_number: 1,
				  start_seconds: 0,
				  end_seconds: 17.24,
				  start_timecode: "00:00:00.000",
				  end_timecode: "00:00:17.958",
				  start_frame: 0,
				  end_frame: 431,
				},
				{
				  scene_number: 2,
				  start_seconds: 17.24,
				  end_seconds: 21.8,
				  start_timecode: "00:00:17.958",
				  end_timecode: "00:00:22.708",
				  start_frame: 431,
				  end_frame: 545,
				},
				{
				  scene_number: 3,
				  start_seconds: 21.8,
				  end_seconds: 25.08,
				  start_timecode: "00:00:22.708",
				  end_timecode: "00:00:26.125",
				  start_frame: 545,
				  end_frame: 627,
				},
				{
				  scene_number: 4,
				  start_seconds: 25.08,
				  end_seconds: 35.72,
				  start_timecode: "00:00:26.125",
				  end_timecode: "00:00:37.208",
				  start_frame: 627,
				  end_frame: 893,
				},
			  ],
			  rendered_video_path: null,
			  rendered_video_url: null,
			},
			video_info: {
			  fps: 24,
			  processing_fps: 25,
			  total_frames: 894,
			  duration: 37.291,
			  start_time: 0,
			  end_time: 37.291,
			  frame_numbers_start_from: 0,
			  resolution: {
				width: 1920,
				height: 960,
			  },
			},
			detection_count: 894,
			scenes_count: 4,
			has_rendered_video: false,
			config: null,
		  },
		},
		metadata: {
		  previewUrl: "",
		},
		duration: 37209.899999999834,
		playbackRate: 1,
	  },
	  uvgcp8zsvO: {
		id: "uvgcp8zsvO",
		name: "Caption 1",
		type: "caption",
		duration: 1300.000000000182,
		display: {
		  from: 209.8999999998341,
		  to: 1509.900000000016,
		},
		metadata: {
		},
		details: {
		  text: "he up to",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "he",
			  start: 209.8999999998341,
			  end: 709.8999999998341,
			  originalWord: "he",
			},
			{
			  word: "up",
			  start: 476.566666666713,
			  end: 976.566666666713,
			  originalWord: "up",
			},
			{
			  word: "to?",
			  start: 609.8999999999251,
			  end: 1109.899999999925,
			  originalWord: "to?",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  XQ3bP3i9lg: {
		id: "XQ3bP3i9lg",
		name: "Caption 2",
		type: "caption",
		duration: 1099.999999999909,
		display: {
		  from: 1509.900000000016,
		  to: 2609.899999999925,
		},
		metadata: {
		},
		details: {
		  text: "They don't just you don't",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "They",
			  start: 1509.900000000016,
			  end: 2009.900000000016,
			  originalWord: "They",
			},
			{
			  word: "don't",
			  start: 1676.566666666531,
			  end: 2176.566666666531,
			  originalWord: "don't",
			},
			{
			  word: "just",
			  start: 1909.900000000107,
			  end: 2409.900000000107,
			  originalWord: "just",
			},
			{
			  word: "you",
			  start: 2309.899999999743,
			  end: 2809.899999999743,
			  originalWord: "you",
			},
			{
			  word: "don't",
			  start: 2376.566666666804,
			  end: 2876.566666666804,
			  originalWord: "don't",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  CMNvZJgPvy: {
		id: "CMNvZJgPvy",
		name: "Caption 3",
		type: "caption",
		duration: 1133.333333333212,
		display: {
		  from: 2609.899999999925,
		  to: 3743.233333333137,
		},
		metadata: {
		},
		details: {
		  text: "just step out of Hollywood",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "just",
			  start: 2609.899999999925,
			  end: 3109.899999999925,
			  originalWord: "just",
			},
			{
			  word: "step",
			  start: 2876.566666666804,
			  end: 3376.566666666804,
			  originalWord: "step",
			},
			{
			  word: "out",
			  start: 3109.899999999925,
			  end: 3609.899999999925,
			  originalWord: "out",
			},
			{
			  word: "of",
			  start: 3176.566666666531,
			  end: 3676.566666666531,
			  originalWord: "of",
			},
			{
			  word: "Hollywood",
			  start: 3343.233333333046,
			  end: 3843.233333333046,
			  originalWord: "Hollywood",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  aVI8ZJjjJq: {
		id: "aVI8ZJjjJq",
		name: "Caption 4",
		type: "caption",
		duration: 1133.3333333336668,
		display: {
		  from: 3743.233333333137,
		  to: 4876.566666666804,
		},
		metadata: {
		},
		details: {
		  text: "and enter unless you get",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "and",
			  start: 3743.233333333137,
			  end: 4243.233333333137,
			  originalWord: "and",
			},
			{
			  word: "enter",
			  start: 3976.566666666713,
			  end: 4476.566666666713,
			  originalWord: "enter",
			},
			{
			  word: "unless",
			  start: 4309.899999999743,
			  end: 4809.899999999743,
			  originalWord: "unless",
			},
			{
			  word: "you",
			  start: 4543.233333333319,
			  end: 5043.233333333319,
			  originalWord: "you",
			},
			{
			  word: "get",
			  start: 4709.899999999834,
			  end: 5209.899999999834,
			  originalWord: "get",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  TfDAfb1Yz6: {
		id: "TfDAfb1Yz6",
		name: "Caption 5",
		type: "caption",
		duration: 866.6666666663332,
		display: {
		  from: 4876.566666666804,
		  to: 5743.233333333137,
		},
		metadata: {
		},
		details: {
		  text: "you turn that down because",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "you",
			  start: 4876.566666666804,
			  end: 5376.566666666804,
			  originalWord: "you",
			},
			{
			  word: "turn",
			  start: 5009.900000000016,
			  end: 5509.900000000016,
			  originalWord: "turn",
			},
			{
			  word: "that",
			  start: 5176.566666666531,
			  end: 5676.566666666531,
			  originalWord: "that",
			},
			{
			  word: "down",
			  start: 5343.233333333046,
			  end: 5843.233333333046,
			  originalWord: "down",
			},
			{
			  word: "because",
			  start: 5509.900000000016,
			  end: 6009.900000000016,
			  originalWord: "because",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  ipKBwjNfT2: {
		id: "ipKBwjNfT2",
		name: "Caption 6",
		type: "caption",
		duration: 866.6666666667879,
		display: {
		  from: 5743.233333333137,
		  to: 6609.899999999925,
		},
		metadata: {
		},
		details: {
		  text: "you got a plan",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "you",
			  start: 5743.233333333137,
			  end: 6243.233333333137,
			  originalWord: "you",
			},
			{
			  word: "got",
			  start: 5809.899999999743,
			  end: 6309.899999999743,
			  originalWord: "got",
			},
			{
			  word: "a",
			  start: 6076.566666666622,
			  end: 6576.566666666622,
			  originalWord: "a",
			},
			{
			  word: "plan.",
			  start: 6143.233333333228,
			  end: 6643.233333333228,
			  originalWord: "plan.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  kZw1Jt9twx: {
		id: "kZw1Jt9twx",
		name: "Caption 7",
		type: "caption",
		duration: 1199.999999999818,
		display: {
		  from: 6609.899999999925,
		  to: 7809.899999999743,
		},
		metadata: {
		},
		details: {
		  text: "You got somewhere you want",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "You",
			  start: 6609.899999999925,
			  end: 7109.899999999925,
			  originalWord: "You",
			},
			{
			  word: "got",
			  start: 6876.566666666804,
			  end: 7376.566666666804,
			  originalWord: "got",
			},
			{
			  word: "somewhere",
			  start: 7009.900000000016,
			  end: 7509.900000000016,
			  originalWord: "somewhere",
			},
			{
			  word: "you",
			  start: 7409.900000000107,
			  end: 7909.900000000107,
			  originalWord: "you",
			},
			{
			  word: "want",
			  start: 7576.566666666622,
			  end: 8076.566666666622,
			  originalWord: "want",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  ZK8MskuIGO: {
		id: "ZK8MskuIGO",
		name: "Caption 8",
		type: "caption",
		duration: 333.3333333334849,
		display: {
		  from: 7809.899999999743,
		  to: 8143.233333333228,
		},
		metadata: {
		},
		details: {
		  text: "to go",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "to",
			  start: 7809.899999999743,
			  end: 8309.899999999743,
			  originalWord: "to",
			},
			{
			  word: "go.",
			  start: 7909.900000000107,
			  end: 8409.900000000107,
			  originalWord: "go.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  siDdk3iJYo: {
		id: "siDdk3iJYo",
		name: "Caption 9",
		type: "caption",
		duration: 966.666666666697,
		display: {
		  from: 8143.233333333228,
		  to: 9109.899999999925,
		},
		metadata: {
		},
		details: {
		  text: "And I think that made",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "And",
			  start: 8143.233333333228,
			  end: 8643.233333333228,
			  originalWord: "And",
			},
			{
			  word: "I",
			  start: 8376.566666666804,
			  end: 8876.566666666804,
			  originalWord: "I",
			},
			{
			  word: "think",
			  start: 8476.566666666713,
			  end: 8976.566666666713,
			  originalWord: "think",
			},
			{
			  word: "that",
			  start: 8709.899999999834,
			  end: 9209.899999999834,
			  originalWord: "that",
			},
			{
			  word: "made",
			  start: 8876.566666666804,
			  end: 9376.566666666804,
			  originalWord: "made",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  mxpizvOXKk: {
		id: "mxpizvOXKk",
		name: "Caption 10",
		type: "caption",
		duration: 2566.666666666606,
		display: {
		  from: 9109.899999999925,
		  to: 11676.566666666531,
		},
		metadata: {
		},
		details: {
		  text: "me more attractive as a",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "me",
			  start: 9109.899999999925,
			  end: 9609.899999999925,
			  originalWord: "me",
			},
			{
			  word: "more",
			  start: 9276.56666666644,
			  end: 9776.56666666644,
			  originalWord: "more",
			},
			{
			  word: "attractive",
			  start: 10876.566666666804,
			  end: 11376.566666666804,
			  originalWord: "attractive",
			},
			{
			  word: "as",
			  start: 11409.900000000107,
			  end: 11909.900000000107,
			  originalWord: "as",
			},
			{
			  word: "a",
			  start: 11576.566666666622,
			  end: 12076.566666666622,
			  originalWord: "a",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  fwvjrCtqv4: {
		id: "fwvjrCtqv4",
		name: "Caption 11",
		type: "caption",
		duration: 1033.333333333303,
		display: {
		  from: 11676.566666666531,
		  to: 12709.899999999834,
		},
		metadata: {
		},
		details: {
		  text: "new novel idea",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "new",
			  start: 11676.566666666531,
			  end: 12176.566666666531,
			  originalWord: "new",
			},
			{
			  word: "novel",
			  start: 11909.900000000107,
			  end: 12409.900000000107,
			  originalWord: "novel",
			},
			{
			  word: "idea.",
			  start: 12209.899999999834,
			  end: 12709.899999999834,
			  originalWord: "idea.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  iq6RXhoKRt: {
		id: "iq6RXhoKRt",
		name: "Caption 12",
		type: "caption",
		duration: 1200.0000000002728,
		display: {
		  from: 12709.899999999834,
		  to: 13909.900000000107,
		},
		metadata: {
		},
		details: {
		  text: "But that was yeah",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "But",
			  start: 12709.899999999834,
			  end: 13209.899999999834,
			  originalWord: "But",
			},
			{
			  word: "that",
			  start: 12876.566666666804,
			  end: 13376.566666666804,
			  originalWord: "that",
			},
			{
			  word: "was",
			  start: 12943.23333333341,
			  end: 13443.23333333341,
			  originalWord: "was",
			},
			{
			  word: "yeah.",
			  start: 13676.566666666531,
			  end: 14176.566666666531,
			  originalWord: "yeah.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  aoLsSSJqzW: {
		id: "aoLsSSJqzW",
		name: "Caption 13",
		type: "caption",
		duration: 966.666666666697,
		display: {
		  from: 13909.900000000107,
		  to: 14876.566666666804,
		},
		metadata: {
		},
		details: {
		  text: "That risk took a I",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "That",
			  start: 13909.900000000107,
			  end: 14409.900000000107,
			  originalWord: "That",
			},
			{
			  word: "risk",
			  start: 14076.566666666622,
			  end: 14576.566666666622,
			  originalWord: "risk",
			},
			{
			  word: "took",
			  start: 14309.899999999743,
			  end: 14809.899999999743,
			  originalWord: "took",
			},
			{
			  word: "a",
			  start: 14543.233333333319,
			  end: 15043.233333333319,
			  originalWord: "a",
			},
			{
			  word: "I",
			  start: 14776.56666666644,
			  end: 15276.56666666644,
			  originalWord: "I",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  VXR0nkI1Er: {
		id: "VXR0nkI1Er",
		name: "Caption 14",
		type: "caption",
		duration: 966.6666666662422,
		display: {
		  from: 14876.566666666804,
		  to: 15843.233333333046,
		},
		metadata: {
		},
		details: {
		  text: "think it's fair to say",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "think",
			  start: 14876.566666666804,
			  end: 15376.566666666804,
			  originalWord: "think",
			},
			{
			  word: "it's",
			  start: 15109.899999999925,
			  end: 15609.899999999925,
			  originalWord: "it's",
			},
			{
			  word: "fair",
			  start: 15343.233333333046,
			  end: 15843.233333333046,
			  originalWord: "fair",
			},
			{
			  word: "to",
			  start: 15509.900000000016,
			  end: 16009.900000000016,
			  originalWord: "to",
			},
			{
			  word: "say",
			  start: 15576.566666666622,
			  end: 16076.566666666622,
			  originalWord: "say",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  "2QBzzaAXn1": {
		id: "2QBzzaAXn1",
		name: "Caption 15",
		type: "caption",
		duration: 1033.3333333337578,
		display: {
		  from: 15843.233333333046,
		  to: 16876.566666666804,
		},
		metadata: {
		},
		details: {
		  text: "that took a fair amount",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "that",
			  start: 15843.233333333046,
			  end: 16343.233333333046,
			  originalWord: "that",
			},
			{
			  word: "took",
			  start: 15976.566666666713,
			  end: 16476.566666666713,
			  originalWord: "took",
			},
			{
			  word: "a",
			  start: 16143.233333333228,
			  end: 16643.233333333228,
			  originalWord: "a",
			},
			{
			  word: "fair",
			  start: 16376.566666666804,
			  end: 16876.566666666804,
			  originalWord: "fair",
			},
			{
			  word: "amount",
			  start: 16643.233333333228,
			  end: 17143.233333333228,
			  originalWord: "amount",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  AFQfg9AuDP: {
		id: "AFQfg9AuDP",
		name: "Caption 16",
		type: "caption",
		duration: 1366.6666666663332,
		display: {
		  from: 16876.566666666804,
		  to: 18243.233333333137,
		},
		metadata: {
		},
		details: {
		  text: "of courage from me",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "of",
			  start: 16876.566666666804,
			  end: 17376.566666666804,
			  originalWord: "of",
			},
			{
			  word: "courage",
			  start: 17043.23333333332,
			  end: 17543.23333333332,
			  originalWord: "courage",
			},
			{
			  word: "from",
			  start: 17343.233333333046,
			  end: 17843.233333333046,
			  originalWord: "from",
			},
			{
			  word: "me.",
			  start: 17509.900000000016,
			  end: 18009.900000000016,
			  originalWord: "me.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  "4JFwUk9GmB": {
		id: "4JFwUk9GmB",
		name: "Caption 17",
		type: "caption",
		duration: 700.0000000002728,
		display: {
		  from: 18243.233333333137,
		  to: 18943.23333333341,
		},
		metadata: {
		},
		details: {
		  text: "The quick aside",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "The",
			  start: 18243.233333333137,
			  end: 18743.233333333137,
			  originalWord: "The",
			},
			{
			  word: "quick",
			  start: 18376.566666666804,
			  end: 18876.566666666804,
			  originalWord: "quick",
			},
			{
			  word: "aside,",
			  start: 18643.233333333228,
			  end: 19143.233333333228,
			  originalWord: "aside,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  tToHIEWjnd: {
		id: "tToHIEWjnd",
		name: "Caption 18",
		type: "caption",
		duration: 966.666666666697,
		display: {
		  from: 18943.23333333341,
		  to: 19909.900000000107,
		},
		metadata: {
		},
		details: {
		  text: "if you've been feeling a",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "if",
			  start: 18943.23333333341,
			  end: 19443.23333333341,
			  originalWord: "if",
			},
			{
			  word: "you've",
			  start: 19043.23333333332,
			  end: 19543.23333333332,
			  originalWord: "you've",
			},
			{
			  word: "been",
			  start: 19276.56666666644,
			  end: 19776.56666666644,
			  originalWord: "been",
			},
			{
			  word: "feeling",
			  start: 19443.23333333341,
			  end: 19943.23333333341,
			  originalWord: "feeling",
			},
			{
			  word: "a",
			  start: 19843.233333333046,
			  end: 20343.233333333046,
			  originalWord: "a",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  V0LkAnG8Gt: {
		id: "V0LkAnG8Gt",
		name: "Caption 19",
		type: "caption",
		duration: 633.3333333332121,
		display: {
		  from: 19909.900000000107,
		  to: 20543.23333333332,
		},
		metadata: {
		},
		details: {
		  text: "bit sluggish",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "bit",
			  start: 19909.900000000107,
			  end: 20409.900000000107,
			  originalWord: "bit",
			},
			{
			  word: "sluggish,",
			  start: 20143.233333333228,
			  end: 20643.233333333228,
			  originalWord: "sluggish,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  hGcqBOtqQz: {
		id: "hGcqBOtqQz",
		name: "Caption 20",
		type: "caption",
		duration: 1699.999999999818,
		display: {
		  from: 20543.23333333332,
		  to: 22243.233333333137,
		},
		metadata: {
		},
		details: {
		  text: "your testosterone levels might be",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "your",
			  start: 20543.23333333332,
			  end: 21043.23333333332,
			  originalWord: "your",
			},
			{
			  word: "testosterone",
			  start: 20776.56666666644,
			  end: 21276.56666666644,
			  originalWord: "testosterone",
			},
			{
			  word: "levels",
			  start: 21276.56666666644,
			  end: 21776.56666666644,
			  originalWord: "levels",
			},
			{
			  word: "might",
			  start: 21909.900000000107,
			  end: 22409.900000000107,
			  originalWord: "might",
			},
			{
			  word: "be",
			  start: 22143.233333333228,
			  end: 22643.233333333228,
			  originalWord: "be",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  RDUtPKkHG1: {
		id: "RDUtPKkHG1",
		name: "Caption 21",
		type: "caption",
		duration: 400.00000000009095,
		display: {
		  from: 22243.233333333137,
		  to: 22643.233333333228,
		},
		metadata: {
		},
		details: {
		  text: "the problem",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "the",
			  start: 22243.233333333137,
			  end: 22743.233333333137,
			  originalWord: "the",
			},
			{
			  word: "problem.",
			  start: 22309.899999999743,
			  end: 22809.899999999743,
			  originalWord: "problem.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  s3r2upxV7q: {
		id: "s3r2upxV7q",
		name: "Caption 22",
		type: "caption",
		duration: 1333.333333333485,
		display: {
		  from: 22643.233333333228,
		  to: 23976.566666666713,
		},
		metadata: {
		},
		details: {
		  text: "They play a huge role",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "They",
			  start: 22643.233333333228,
			  end: 23143.233333333228,
			  originalWord: "They",
			},
			{
			  word: "play",
			  start: 22876.566666666804,
			  end: 23376.566666666804,
			  originalWord: "play",
			},
			{
			  word: "a",
			  start: 23176.56666666653,
			  end: 23676.56666666653,
			  originalWord: "a",
			},
			{
			  word: "huge",
			  start: 23343.233333333046,
			  end: 23843.233333333046,
			  originalWord: "huge",
			},
			{
			  word: "role",
			  start: 23676.56666666653,
			  end: 24176.56666666653,
			  originalWord: "role",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  i9WiHFwaZx: {
		id: "i9WiHFwaZx",
		name: "Caption 23",
		type: "caption",
		duration: 799.9999999997272,
		display: {
		  from: 23976.566666666713,
		  to: 24776.56666666644,
		},
		metadata: {
		},
		details: {
		  text: "in your energy",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "in",
			  start: 23976.566666666713,
			  end: 24476.566666666713,
			  originalWord: "in",
			},
			{
			  word: "your",
			  start: 24143.233333333228,
			  end: 24643.233333333228,
			  originalWord: "your",
			},
			{
			  word: "energy,",
			  start: 24376.566666666804,
			  end: 24876.566666666804,
			  originalWord: "energy,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  XHcNu5RA7j: {
		id: "XHcNu5RA7j",
		name: "Caption 24",
		type: "caption",
		duration: 400.00000000009095,
		display: {
		  from: 24776.56666666644,
		  to: 25176.56666666653,
		},
		metadata: {
		},
		details: {
		  text: "focus",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "focus,",
			  start: 24776.56666666644,
			  end: 25276.56666666644,
			  originalWord: "focus,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  LttElnxyNF: {
		id: "LttElnxyNF",
		name: "Caption 25",
		type: "caption",
		duration: 666.6666666665151,
		display: {
		  from: 25176.56666666653,
		  to: 25843.233333333046,
		},
		metadata: {
		},
		details: {
		  text: "and performance",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "and",
			  start: 25176.56666666653,
			  end: 25676.56666666653,
			  originalWord: "and",
			},
			{
			  word: "performance,",
			  start: 25343.233333333046,
			  end: 25843.233333333046,
			  originalWord: "performance,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  FvtShUoCG7: {
		id: "FvtShUoCG7",
		name: "Caption 26",
		type: "caption",
		duration: 1333.333333333485,
		display: {
		  from: 25843.233333333046,
		  to: 27176.56666666653,
		},
		metadata: {
		},
		details: {
		  text: "but most people have no",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "but",
			  start: 25843.233333333046,
			  end: 26343.233333333046,
			  originalWord: "but",
			},
			{
			  word: "most",
			  start: 26143.233333333228,
			  end: 26643.233333333228,
			  originalWord: "most",
			},
			{
			  word: "people",
			  start: 26309.899999999743,
			  end: 26809.899999999743,
			  originalWord: "people",
			},
			{
			  word: "have",
			  start: 26709.899999999834,
			  end: 27209.899999999834,
			  originalWord: "have",
			},
			{
			  word: "no",
			  start: 27043.23333333332,
			  end: 27543.23333333332,
			  originalWord: "no",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  uNBr0t57X1: {
		id: "uNBr0t57X1",
		name: "Caption 27",
		type: "caption",
		duration: 1300.000000000182,
		display: {
		  from: 27176.56666666653,
		  to: 28476.566666666713,
		},
		metadata: {
		},
		details: {
		  text: "idea where those are or",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "idea",
			  start: 27176.56666666653,
			  end: 27676.56666666653,
			  originalWord: "idea",
			},
			{
			  word: "where",
			  start: 27509.900000000016,
			  end: 28009.900000000016,
			  originalWord: "where",
			},
			{
			  word: "those",
			  start: 27676.56666666653,
			  end: 28176.56666666653,
			  originalWord: "those",
			},
			{
			  word: "are",
			  start: 27909.900000000107,
			  end: 28409.900000000107,
			  originalWord: "are",
			},
			{
			  word: "or",
			  start: 28143.233333333228,
			  end: 28643.233333333228,
			  originalWord: "or",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  dSPhLADnfr: {
		id: "dSPhLADnfr",
		name: "Caption 28",
		type: "caption",
		duration: 1199.999999999818,
		display: {
		  from: 28476.566666666713,
		  to: 29676.56666666653,
		},
		metadata: {
		},
		details: {
		  text: "what to do if something's",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "what",
			  start: 28476.566666666713,
			  end: 28976.566666666713,
			  originalWord: "what",
			},
			{
			  word: "to",
			  start: 28709.899999999834,
			  end: 29209.899999999834,
			  originalWord: "to",
			},
			{
			  word: "do",
			  start: 28776.56666666644,
			  end: 29276.56666666644,
			  originalWord: "do",
			},
			{
			  word: "if",
			  start: 29209.899999999834,
			  end: 29709.899999999834,
			  originalWord: "if",
			},
			{
			  word: "something's",
			  start: 29343.233333333046,
			  end: 29843.233333333046,
			  originalWord: "something's",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  zSX1rAAQRY: {
		id: "zSX1rAAQRY",
		name: "Caption 29",
		type: "caption",
		duration: 233.33333333357587,
		display: {
		  from: 29676.56666666653,
		  to: 29909.900000000107,
		},
		metadata: {
		},
		details: {
		  text: "off",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "off,",
			  start: 29676.56666666653,
			  end: 30176.56666666653,
			  originalWord: "off,",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  QRdPzwmyAf: {
		id: "QRdPzwmyAf",
		name: "Caption 30",
		type: "caption",
		duration: 1299.9999999997272,
		display: {
		  from: 29909.900000000107,
		  to: 31209.899999999834,
		},
		metadata: {
		},
		details: {
		  text: "which is why I partnered",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "which",
			  start: 29909.900000000107,
			  end: 30409.900000000107,
			  originalWord: "which",
			},
			{
			  word: "is",
			  start: 30143.233333333228,
			  end: 30643.233333333228,
			  originalWord: "is",
			},
			{
			  word: "why",
			  start: 30309.899999999743,
			  end: 30809.899999999743,
			  originalWord: "why",
			},
			{
			  word: "I",
			  start: 30709.899999999834,
			  end: 31209.899999999834,
			  originalWord: "I",
			},
			{
			  word: "partnered",
			  start: 30876.566666666804,
			  end: 31376.566666666804,
			  originalWord: "partnered",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  DsYPnfZfR8: {
		id: "DsYPnfZfR8",
		name: "Caption 31",
		type: "caption",
		duration: 1099.999999999909,
		display: {
		  from: 31209.899999999834,
		  to: 32309.899999999743,
		},
		metadata: {
		},
		details: {
		  text: "with function because I wanted",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "with",
			  start: 31209.899999999834,
			  end: 31709.899999999834,
			  originalWord: "with",
			},
			{
			  word: "function",
			  start: 31343.233333333046,
			  end: 31843.233333333046,
			  originalWord: "function",
			},
			{
			  word: "because",
			  start: 31676.56666666653,
			  end: 32176.56666666653,
			  originalWord: "because",
			},
			{
			  word: "I",
			  start: 31909.900000000107,
			  end: 32409.900000000107,
			  originalWord: "I",
			},
			{
			  word: "wanted",
			  start: 32076.566666666622,
			  end: 32576.566666666622,
			  originalWord: "wanted",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  "3bgnTk4z7L": {
		id: "3bgnTk4z7L",
		name: "Caption 32",
		type: "caption",
		duration: 1700.0000000002728,
		display: {
		  from: 32309.899999999743,
		  to: 34009.900000000016,
		},
		metadata: {
		},
		details: {
		  text: "a smarter and more comprehensive",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "a",
			  start: 32309.899999999743,
			  end: 32809.89999999975,
			  originalWord: "a",
			},
			{
			  word: "smarter",
			  start: 32543.23333333332,
			  end: 33043.23333333332,
			  originalWord: "smarter",
			},
			{
			  word: "and",
			  start: 32943.23333333341,
			  end: 33443.23333333341,
			  originalWord: "and",
			},
			{
			  word: "more",
			  start: 33043.23333333332,
			  end: 33543.23333333332,
			  originalWord: "more",
			},
			{
			  word: "comprehensive",
			  start: 33343.233333333046,
			  end: 33843.233333333046,
			  originalWord: "comprehensive",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  nNq1Dw1Pqy: {
		id: "nNq1Dw1Pqy",
		name: "Caption 33",
		type: "caption",
		duration: 1599.9999999999054,
		display: {
		  from: 34009.900000000016,
		  to: 35609.89999999992,
		},
		metadata: {
		},
		details: {
		  text: "way to understand what's actually",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "way",
			  start: 34009.900000000016,
			  end: 34509.900000000016,
			  originalWord: "way",
			},
			{
			  word: "to",
			  start: 34309.89999999975,
			  end: 34809.89999999975,
			  originalWord: "to",
			},
			{
			  word: "understand",
			  start: 34543.23333333332,
			  end: 35043.23333333332,
			  originalWord: "understand",
			},
			{
			  word: "what's",
			  start: 34943.23333333341,
			  end: 35443.23333333341,
			  originalWord: "what's",
			},
			{
			  word: "actually",
			  start: 35276.56666666644,
			  end: 35776.56666666644,
			  originalWord: "actually",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  BOizRdHuoF: {
		id: "BOizRdHuoF",
		name: "Caption 34",
		type: "caption",
		duration: 1599.9999999999127,
		display: {
		  from: 35609.89999999992,
		  to: 37209.899999999834,
		},
		metadata: {
		},
		details: {
		  text: "happening inside of my body",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "happening",
			  start: 35609.89999999992,
			  end: 36109.89999999992,
			  originalWord: "happening",
			},
			{
			  word: "inside",
			  start: 36309.89999999975,
			  end: 36809.89999999975,
			  originalWord: "inside",
			},
			{
			  word: "of",
			  start: 36643.23333333323,
			  end: 37143.23333333323,
			  originalWord: "of",
			},
			{
			  word: "my",
			  start: 36709.899999999834,
			  end: 37209.899999999834,
			  originalWord: "my",
			},
			{
			  word: "body.",
			  start: 36809.89999999975,
			  end: 37309.89999999975,
			  originalWord: "body.",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  Hp7FKjH8mI: {
		id: "Hp7FKjH8mI",
		name: "Caption 35",
		type: "caption",
		duration: 0,
		display: {
		  from: 37209.899999999834,
		  to: 37209.899999999834,
		},
		metadata: {
		},
		details: {
		  text: "Twice",
		  color: "#f30303",
		  fontSize: "60px",
		  backgroundColor: "#f30303",
		  top: "auto",
		  bottom: "15%",
		  left: "15%",
		  zIndex: 1,
		  width: 756,
		  height: "auto",
		  overflow: "visible",
		  textAlign: "center",
		  words: [
			{
			  word: "Twice",
			  start: 37209.899999999834,
			  end: 37709.899999999834,
			  originalWord: "Twice",
			},
		  ],
		  skewX: 0,
		  skewY: 0,
		  lineHeight: 1.2,
		  letterSpacing: 0,
		  fontWeight: 400,
		  fontStyle: "normal",
		  textDecoration: "none",
		  wordSpacing: 0,
		  textShadow: "none",
		  opacity: 100,
		  border: "none",
		  wordWrap: "break-word",
		  wordBreak: "normal",
		  WebkitTextStrokeColor: "transparent",
		  WebkitTextStrokeWidth: "0px",
		  borderWidth: 0,
		  borderColor: "transparent",
		  boxShadow: {
			color: "transparent",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  textTransform: "capitalize",
		},
	  },
	  TSCj230DiT: {
		id: "TSCj230DiT",
		name: "Watermark",
		type: "image",
		playbackRate: 1,
		display: {
		  from: 0,
		  to: 37209.899999999834,
		},
		duration: 37209.899999999834,
		details: {
		  src: "/assets/swiftiawatermark.png",
		  width: 400,
		  height: 250,
		  opacity: 90,
		  transform: "scale(0.5)",
		  border: "none",
		  borderRadius: 0,
		  boxShadow: {
			color: "#000000",
			x: 0,
			y: 0,
			blur: 0,
		  },
		  top: "-32.5px",
		  left: "calc(100% - 330px)",
		  borderWidth: 0,
		  borderColor: "#000000",
		  blur: 0,
		  brightness: 100,
		  flipX: false,
		  flipY: false,
		  rotate: "0deg",
		  visibility: "visible",
		  blendMode: "normal",
		  zIndex: 9999,
		},
		metadata: {
		  previewUrl: "/assets/swiftiawatermark.png",
		},
	  },
	},
	transitionsMap: {
	},
	transitionIds: [
	],
	duration: 37209.899999999834,
	size: {
	  width: 1080,
	  height: 1920,
	},
	fps: 30,
  }